import React from 'react';

const SrFlag = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="30"
    height="20"
    version="1.1"
    viewBox="0 0 756.13 504.09"
  >
    <clipPath>
      <path d="M0 0h756.13v168.35H0z"></path>
    </clipPath>
    <clipPath id="b">
      <path d="M0 167.75h756.13v168.34H0z"></path>
    </clipPath>
    <clipPath id="c">
      <path d="M0 335.51h756.13v168.58H0z"></path>
    </clipPath>
    <g>
      <path
        fill="#c6363c"
        fillOpacity="1"
        fillRule="evenodd"
        strokeWidth="1.732"
        d="M0 0h756.13v504.08H0z"
      ></path>
      <g clipPath="url(#b)" transform="matrix(1 0 0 1.9975 0 -167.202)">
        <path
          fill="#0c4076"
          fillOpacity="1"
          fillRule="evenodd"
          d="M0 167.62h756.13v168.44H0z"
        ></path>
      </g>
      <g clipPath="url(#c)">
        <path
          fill="#fff"
          fillRule="evenodd"
          d="M0 334.79h756.13v169.29H0z"
        ></path>
      </g>
      <g transform="translate(0 .131)">
        <g fillRule="evenodd">
          <g
            fill="#edb92e"
            fillOpacity="1"
            stroke="#21231e"
            strokeMiterlimit="22.926"
            strokeOpacity="1"
          >
            <path
              strokeWidth="0.662"
              d="M-76.327 345.66c2.376.752 5.401-.476 6.066-.9.336-.218 1.188.19 1.527.37 10.785 5.796 11.677 5.809 14.777.485 2.794-4.797 4.803-15.101 6.104-22.456.93-1.613 2.33-2.743 3.416-4.239.738 13.724-2.89 29.154-8.362 37.393-2.893 4.353-10.336.438-21.478-4.106-3.046-3.288-4.467-4.832-2.05-6.547z"
              transform="matrix(.12583 -1 .99997 .12583 0 0)"
            ></path>
            <g strokeWidth="0.667">
              <path
                d="M-338.23-120.62a18.785 18.785 0 00-.691 2.594c-.301 1.492-.172 3.035.328 4.484-1.649 2.317-3.5 4.832-4.832 7.332-.954 1.785-1.692 3.774-1.13 5.809.598 2.172 2.489 3.648 4.2 4.957 2.05 1.566 4.777 2.937 7.543 4.105 6.192 2.551 11.114 3.797 14.723 3.91l-2.289-2.109c-6.715-2.156-14.637-4.996-18.446-7.91-4.934-3.766-4.809-4.66 2.344-14.715.222-.313.738-1.117.566-1.48-.344-.72-.976-4.036.074-6.317-.617-1.152-1.511-.55-2.39-.66z"
                transform="scale(-.99997 -1)"
              ></path>
              <path
                d="M-277.8-75.855c.063 1.273-.023 1.055-.215-.906-.207.394-.476.574-.805.566-.582-.012-.933-.89-.988-2.87.031-.513.07-1.017.106-1.52-18.325.406-29.188-2.356-31.99-7.657-2.304-4.363 1.614-11.586 7.528-19.832.715-1 .695-.914.004-1.738-1.004-1.187-2.078-3.203-1.27-4.969-3.582-1.96-7.847-2.441-11.567-.82-.62 1.633-1.957 2.406-3.043 3.144-.222.149-1.015.54-1.097.793-1.953 6.243-3.918 12.016-5.598 17.391-5.29 16.88 41.696 18.426 48.935 18.418z"
                transform="scale(-.99997 -1)"
              ></path>
              <g strokeLinejoin="round" transform="scale(.99997 -1)">
                <path d="M326.19-148.47c1.813 3.629 3.715 7.191 6.258 10.277-6.512-4.809-9.934-4.086-10.41 2.176-.387.137-.91.137-1.43.137-4.969-7.692-9.8-6.625-14.496 3.195-6.398-10.09-11.887-9.91-16.196.617-7.379-9.203-13.594-9.23-18.649-.195v1.144c.285-.125.09-.164-.57-.07l-.11.207c-.195-.04-.378-.074-.542-.102a20 20 0 00-.547.102l-.106-.207c-.66-.094-.855-.055-.574.07v-1.148c-5.05-9.031-11.266-9.004-18.645.199-4.313-10.527-9.801-10.707-16.196-.617-4.695-9.82-9.528-10.887-14.496-3.195-.523 0-1.043 0-1.43-.137-.476-6.262-3.902-6.985-10.41-2.176 2.54-3.086 4.446-6.648 6.258-10.277 18.758.777 37.454 1.75 56.146 2.727 18.692-.977 37.384-1.95 56.146-2.727z"></path>
                <path d="M333.88-133.36l-2.043.34c-3.918-9.563-7.434-9.797-8.098-.7.879.317.531 1.837 1.524 1.231.523-.32 1.183.586.75 1.086-1.11.816-2.098.688-3.07-.219-.458 1.453-1.579 2.13-2.977 1.52-.606-.266-.399-1.356.207-1.293.98.101.586-.914.894-1.598-6.957-9.062-10.512-7.984-9.645 3.922-1.656.34-3.586.68-5.308 1.293-6.399-12.84-10.953-13.395-14.641-1.871.789.59.566 2.066 1.719 1.59.652-.266 1.199.879.617 1.37-1.348 1.134-2.809.75-3.793-.706-.786 1.57-2.188 2.136-3.668 1.18-.637-.41-.243-1.618.437-1.434 1.305.347.719-1.363 1.707-1.95-2.828-10.831-17.11-11.561-14.774 4.477l-3.672-.133-3.676.133c2.336-16.039-11.942-15.309-14.77-4.476.989.586.403 2.297 1.707 1.949.676-.184 1.075 1.023.434 1.433-1.48.957-2.88.391-3.668-1.18-.98 1.458-2.442 1.84-3.79.708-.581-.492-.035-1.637.614-1.371 1.156.476.93-1 1.723-1.59-3.688-11.523-8.243-10.97-14.641 1.871-1.727-.613-3.653-.953-5.31-1.293.868-11.906-2.69-12.984-9.644-3.922.305.684-.086 1.7.89 1.598.61-.063.817 1.027.212 1.293-1.399.61-2.524-.067-2.977-1.52-.973.907-1.96 1.035-3.07.219-.434-.5.226-1.406.746-1.086.992.606.648-.914 1.523-1.23-.66-9.098-4.176-8.864-8.094.699l-2.043-.34c-.062-2.246.723-4.637 2.11-6.394 5.879-7.458 10.254-5.766 10.414 2.585 7.695-9.02 13.516-7.875 14.559 1.633 6.476-11.996 16.868-6.258 17.082 1.02 2.851-10.574 18.657-10.5 19.668 1.656 1.011-12.156 16.813-12.23 19.668-1.656.215-7.278 10.606-13.016 17.079-1.02 1.047-9.508 6.867-10.652 14.563-1.633.16-8.351 4.531-10.043 10.414-2.585 1.387 1.757 2.172 4.148 2.11 6.394z"></path>
              </g>
            </g>
            <path
              strokeWidth="0.667"
              d="M121.68 283.2c-.545-.867-.4-1.04-.757-1.316-.46-.36-1.216-.364-1.938-.25-2.919.453-2.51-1.297-1.22-3.262.643-.98 2.142-1.973 2.926-2.817.781-.843.848-1.546 1.158-1.757 1.118-.024 2.087-.031 2.526-.024h.004c.436-.008 1.404 0 2.523.024.31.21.376.914 1.16 1.758.781.843 2.28 1.835 2.923 2.816 1.291 1.965 1.7 3.715-1.22 3.262-.721-.114-1.475-.11-1.938.25-.357.277-.211.449-.757 1.316-.353.563-.777.984-1.24 1.266-.459.28-.957.129-1.455.129-.498 0-.992.152-1.455-.13-.46-.28-.887-.703-1.24-1.265z"
              transform="matrix(0 .99572 1 0 0 0)"
            ></path>
          </g>
          <path
            fill="#21231e"
            d="M273.71 124.29l.074.488c2.078.258 3.793 1.09 5.293 2.395-.988-1.469-3.117-2.559-5.367-2.883"
          ></path>
          <path
            fill="#21231e"
            d="M273.71 123.4l.074-.488c2.078-.262 3.793-1.094 5.293-2.399-.988 1.47-3.117 2.563-5.367 2.887"
          ></path>
          <g stroke="#21231e" strokeMiterlimit="22.926" strokeOpacity="1">
            <g fill="#edb92e" fillOpacity="1">
              <path
                strokeWidth="0.667"
                d="M-117.15 281.67c-.258-.633-.535-1.32-1.098-1.902-.855-.887-2.27-.313-3.644.832-.43.363-1.196.535-1.957.53-.762 0-1.52-.179-1.938-.53-1.37-1.145-2.789-1.72-3.644-.832-.563.582-.836 1.27-1.098 1.902.332.059.766.055 1.324-.031.72-.113 1.47-.11 1.926.25.36.277.215.449.758 1.316.351.563.773.985 1.234 1.266.457.281.953.129 1.45.129.496 0 .988.152 1.449-.13.457-.28.883-.702 1.234-1.265.54-.867.399-1.039.75-1.316.461-.36 1.211-.363 1.934-.25.554.086.988.09 1.32.031z"
                transform="matrix(0 -1 .99997 0 0 0)"
              ></path>
              <path
                strokeWidth="0.662"
                d="M-143.23-186.01c2.376.752 5.401-.476 6.066-.904.336-.214 1.192.19 1.527.374 10.785 5.796 11.677 5.805 14.777.485 2.794-4.801 4.803-15.101 6.104-22.456.93-1.613 2.33-2.743 3.416-4.239.738 13.72-2.891 29.15-8.362 37.393-2.893 4.353-10.336.438-21.478-4.106-3.047-3.292-4.468-4.836-2.05-6.547z"
                transform="matrix(-.12583 -1 -.99997 .12583 0 0)"
              ></path>
              <path
                strokeWidth="0.667"
                d="M201.86-120.62a18.21 18.21 0 00-.688 2.594c-.3 1.492-.171 3.035.325 4.484-1.649 2.317-3.496 4.832-4.832 7.332-.95 1.785-1.688 3.774-1.13 5.809.602 2.172 2.493 3.648 4.204 4.957 2.047 1.566 4.777 2.937 7.543 4.105 6.192 2.551 11.114 3.797 14.719 3.91l-2.29-2.109c-6.71-2.156-14.632-4.996-18.441-7.91-4.934-3.766-4.809-4.66 2.344-14.715.222-.313.738-1.117.562-1.48-.34-.72-.972-4.036.078-6.317-.617-1.152-1.515-.55-2.394-.66z"
                transform="scale(.99997 -1)"
              ></path>
              <path
                strokeWidth="0.667"
                d="M262.29-75.855c.063 1.273-.027 1.055-.215-.906-.21.394-.48.574-.808.566-.579-.012-.93-.89-.989-2.87l.106-1.52c-18.321.406-29.184-2.356-31.985-7.657-2.305-4.363 1.613-11.586 7.527-19.832.715-1 .692-.914 0-1.738-1-1.187-2.074-3.203-1.266-4.969-3.586-1.96-7.847-2.441-11.57-.82-.618 1.633-1.958 2.406-3.04 3.144-.222.149-1.02.54-1.097.793-1.957 6.243-3.918 12.016-5.602 17.391-5.285 16.88 41.7 18.426 48.939 18.418z"
                transform="scale(.99997 -1)"
              ></path>
              <path
                strokeWidth="0.616"
                d="M30.169-278.01L46-283.933c-5.999-15.656-12.917-34.277-18.914-49.93l-15.85 2.966c13.112 38.177 19.494 55.63 18.932 52.887z"
                transform="matrix(-.41558 1 -.99998 -.41558 0 0)"
              ></path>
              <g strokeWidth="0.667" transform="scale(.99997 -1)">
                <path d="M265.47-145.71l-.004-.098c-9.692-.43-26.868-1.386-51.607-2.949l3.621-17.082c16.434.461 35.61 1.176 52.564 1.688 16.95-.512 36.13-1.227 52.564-1.688l3.618 17.082c-24.74 1.563-41.911 2.52-51.607 2.95l-.004.097c.98.191-.54.227-4.57.086-4.036.14-5.552.105-4.575-.086z"></path>
                <path d="M270.05-147.73c-.668 0-1.332-.004-2-.004l-.664-.004h-.34l-.617-.004-.371-.004h-.243l-.421-.004-.664-.008-.586-.004-.125-.004-.489-.004c-.484-.008-.969-.012-1.453-.02h-.16l-.094-.003-.617-.008-.191-.004-.262-.004-.637-.012h-.023l-.664-.012-.211-.004-.446-.012h-.144l-.516-.011-.66-.016h-.031l-.63-.015-.265-.004-.02-.004c-.784-.016-1.566-.04-2.347-.06l-.316-.007-.895-.027-.101-.004-.79-.028-.52-.015-.37-.012-.106-.004-.789-.023-.047-.004-.652-.024-.031-.004-.625-.023-.422-.016-.883-.035h-.004a970.415 970.415 0 01-3.48-.148l-.165-.008a691.831 691.831 0 01-5.094-.262l-.097-.008-.254-.012c-3.39-.195-6.762-.414-10.114-.668l-.125-.008-.043-.008c-4.91-.367-9.774-.805-14.59-1.3-2.742-.258-3.266 2.972 0 3.273 4.816.5 9.68.933 14.59 1.304l.043.004c6.738.508 13.555.899 20.45 1.16l.566.024h.09l.188.008.652.023.05.004c2.817.098 5.65.18 8.497.235l.445.008.024.004.758.012h.093l.024.004.636.008.262.008.399.004.504.008.16.004.234.004 1.754.023.555.004h.11l.663.004c.645.008 1.29.012 1.938.016h.055l.664.004c.668 0 1.332.004 2 .004.664 0 1.332-.004 1.996-.004l.668-.004h.055c.644-.004 1.293-.008 1.937-.016l.664-.004h.11l.554-.004 1.754-.023.235-.004.16-.004.5-.008.402-.004.262-.008.637-.008.023-.004h.098l.754-.012.023-.004.445-.008c2.844-.055 5.68-.137 8.5-.235l.044-.004.656-.023.187-.008h.086l.57-.023a549.402 549.402 0 0020.45-1.16l.04-.005c4.91-.37 9.773-.804 14.59-1.304 3.27-.301 2.742-3.531 0-3.274-4.817.496-9.68.934-14.59 1.301l-.04.008-.124.008c-3.352.254-6.723.473-10.114.668l-.254.012-.094.008c-1.695.094-3.395.18-5.098.262l-.164.008c-1.16.05-2.32.101-3.48.148h-.004l-.883.035-.426.016-.625.023-.028.004-.656.024-.043.004-.793.023-.101.004-.371.012-.52.015-.793.028-.098.004-.894.027-.32.008c-.778.02-1.563.043-2.344.059l-.02.004-.265.004-.63.015h-.03l-.66.016-.516.011h-.145l-.445.012-.215.004-.66.012h-.024l-.636.012-.262.004-.192.004-.617.008-.093.004h-.16c-.485.008-.97.011-1.454.019l-.488.004-.125.004-.586.004-.664.008-.422.004h-.242l-.371.004-.618.004h-.34l-.667.004c-.664.004-1.332.004-1.996.004z"></path>
              </g>
            </g>
            <g fill="#fff" strokeWidth="0.667">
              <path
                d="M227.29-107.74a3.53 3.53 0 003.531-3.527 3.53 3.53 0 00-7.058 0 3.528 3.528 0 003.527 3.527z"
                transform="scale(.99998 -1)"
              ></path>
              <g transform="scale(.99997 -1)">
                <path d="M197.23-115.13a3.28 3.28 0 003.277-3.277 3.28 3.28 0 00-3.277-3.278 3.28 3.28 0 00-3.277 3.278 3.28 3.28 0 003.277 3.277z"></path>
                <path d="M194.1-109.14a3.277 3.277 0 10.001-6.553 3.277 3.277 0 00-.001 6.553z"></path>
                <path d="M191.15-103.09a3.277 3.277 0 10.001-6.556 3.277 3.277 0 00-.001 6.556z"></path>
              </g>
            </g>
            <path
              fill="#edb92e"
              fillOpacity="1"
              strokeWidth="0.667"
              d="M270.05-119.56a4.286 4.286 0 004.285-4.281 4.29 4.29 0 00-4.285-4.29 4.288 4.288 0 00-4.285 4.29 4.284 4.284 0 004.285 4.281z"
              transform="scale(.99998 -1)"
            ></path>
            <path
              fill="#edb92e"
              fillOpacity="1"
              strokeWidth="0.667"
              d="M240.42-130.56c1.896.001 1.202-3.323.778-4.045-.552-.943-1.006-.944-1.556 0-.424.724-1.114 4.044.778 4.045z"
              transform="matrix(.99925 -.06748 -.06753 -1 0 0)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0.665"
              d="M240.24-132.38c4.45 0 2.82-7.808 1.827-9.502-1.294-2.218-2.36-2.216-3.656-.003-.995 1.7-2.624 9.505 1.829 9.505z"
              transform="matrix(.99997 -.06753 -.06753 -1 0 0)"
            ></path>
            <path
              fill="#edb92e"
              fillOpacity="1"
              strokeWidth="0.637"
              d="M159.39-169.78c1.81-.001 1.147-3.173.744-3.862-.53-.902-.963-.9-1.49-.003-.402.69-1.064 3.866.746 3.865z"
              transform="matrix(.99924 -.31799 -.3182 -1 0 0)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0.635"
              d="M159.27-171.52c4.255.002 2.699-7.453 1.749-9.076-1.24-2.114-2.255-2.115-3.496.003-.95 1.619-2.503 9.074 1.747 9.073z"
              transform="matrix(.99997 -.31822 -.31821 -1 0 0)"
            ></path>
            <g strokeWidth="0.667" transform="scale(.99997 -1)">
              <path
                fill="#edb92e"
                fillOpacity="1"
                strokeLinejoin="round"
                d="M260.1-78.922c-9.547.863-19.313-.11-28.981-3.945-8.149-3.235-7.352-12.68 2.586-25.793-.898-1.66-1.41-3.723-1.492-6.11 1.05.059 1.789.031 2.715.055-.72 1.586.086 3.531.996 4.902.597.899.715.739 0 1.739-5.914 8.246-9.832 15.469-7.528 19.832 2.801 5.3 13.664 8.062 31.985 7.656-.03.484-.066.972-.097 1.465-.059.066-.121.132-.184.199z"
              ></path>
              <g fill="#fff">
                <path d="M213.76-81.609a3.403 3.403 0 10.006-6.807 3.403 3.403 0 00-.006 6.807z"></path>
                <path d="M220.44-79.43a3.402 3.402 0 100-6.805 3.402 3.402 0 000 6.805z"></path>
              </g>
            </g>
            <g fill="#edb92e" fillOpacity="1">
              <path
                strokeWidth="0.667"
                d="M221.32-82.332c.336-.45.676-.898 1.016-1.352-5.375-2.949-7.602-6.058-7.075-9.183.09-.54 1.723-6.262 5.375-17.355 2.497-1.723 4.356-3.27 5.579-4.63-.137-.151.394-.636.238-.769.371-1.695-1.54-1.351-2.82-.93-.618 1.626-2.504 3.356-3.586 4.094-.223.149-1.02.54-1.098.793-1.957 6.243-3.918 12.016-5.602 17.391-1.691 5.403 1.973 9.227 7.973 11.941z"
                transform="scale(.99997 -1)"
              ></path>
              <path
                strokeLinejoin="round"
                strokeWidth="0.665"
                d="M190.93-135.37l-.276-1.071c-1.584-.256-2.923-.255-4.016-.001 1.974 1.682 3.376 1.97 4.292 1.072z"
                transform="matrix(.99997 -.0678 -.0678 -1 0 0)"
              ></path>
              <path
                strokeWidth="0.668"
                d="M119.94-200c.219-.98.383-1.075.457-1.5.094-.551.055-1.31-.402-1.83-1.274-2.129 1.023-2.176 2.742-1.347 1.246.597 2.656.289 3.723-.278 1.261-.676 1.835-.535 2.175-.058.22.332.422.648.602.933.676.571.559 1.009-.324 1.087-.875 2.125-2.91 2.829-4.703 3.462-2.621.934-3.243 4.31-4.27-.469z"
                transform="matrix(0 1 -.99966 0 0 0)"
              ></path>
              <path
                strokeWidth="0.667"
                d="M201.13-120.03c1.855-.656 2.062.367 3.31.316-.492-2.828-.99-4.293-3.948-2.777-1.628.84-3.718-.387-4.117-1.297-.14-.332-1.092.36-1.44 1.117-1.452 3.168 3.714 3.524 6.195 2.641z"
                transform="scale(.99818 -1)"
              ></path>
            </g>
            <g fill="#fff" strokeWidth="0.667">
              <g transform="scale(.99998 -1)">
                <path d="M257.13-71.613a3.387 3.387 0 100-6.774 3.387 3.387 0 000 6.774z"></path>
                <path d="M250.19-71.613a3.387 3.387 0 100-6.773 3.386 3.386 0 100 6.773z"></path>
                <path d="M243.25-72.16a3.383 3.383 0 003.387-3.387 3.386 3.386 0 10-6.774 0 3.383 3.383 0 003.387 3.387z"></path>
                <path d="M236.85-73.383c1.871 0 3.39-1.52 3.39-3.39a3.39 3.39 0 10-3.39 3.39z"></path>
              </g>
              <g transform="scale(.99997 -1)">
                <path d="M194.76-90.836a3.402 3.402 0 100-6.805 3.402 3.402 0 000 6.805z"></path>
                <path d="M200.59-87.16a3.4 3.4 0 003.402-3.402 3.402 3.402 0 10-3.402 3.402z"></path>
                <path d="M207.22-84.051a3.402 3.402 0 10-3.402-3.398 3.402 3.402 0 003.402 3.398z"></path>
                <path d="M190.25-96.367a3.402 3.402 0 100-6.805 3.402 3.402 0 000 6.805z"></path>
              </g>
            </g>
            <path
              fill="#edb92e"
              fillOpacity="1"
              strokeWidth="0.667"
              d="M257.44-155.05l12.602 6.305 12.606-6.305-12.606-6.3z"
              transform="scale(.99997 -1)"
            ></path>
            <path
              fill="#0c4076"
              fillOpacity="1"
              strokeWidth="0.667"
              d="M151.89 270.04c0 3.133 1.703 5.668 3.799 5.668 2.1 0 3.799-2.535 3.799-5.668s-1.7-5.672-3.8-5.672c-2.095 0-3.798 2.54-3.798 5.672z"
              transform="matrix(0 .99538 1 0 0 0)"
            ></path>
            <path
              fill="#edb92e"
              fillOpacity="1"
              strokeWidth="0.666"
              d="M219.03-170.03l12.58 6.285 12.581-6.288-12.58-6.286z"
              transform="matrix(.99997 -.06114 -.06114 -1 0 0)"
            ></path>
            <path
              fill="#c6363c"
              fillOpacity="1"
              strokeWidth="0.666"
              d="M-166.94-231.6c.004-3.13-1.694-5.663-3.79-5.66-2.091-.002-3.792 2.531-3.788 5.66-.004 3.125 1.694 5.659 3.79 5.66 2.09-.002 3.792-2.535 3.788-5.66z"
              transform="matrix(-.06085 -.99538 -1 .06112 0 0)"
            ></path>
            <g strokeWidth="0.667" transform="scale(.99997 -1)">
              <path
                fill="#edb92e"
                fillOpacity="1"
                d="M214.76-151.57l13.176-4.988-10.879-7.278c-2.82.938-5.055 10.52-2.297 12.266z"
              ></path>
              <path
                fill="#0c4076"
                fillOpacity="1"
                d="M215.01-154c3.117.32 5.817-1.105 6.027-3.184.211-2.078-2.144-4.02-5.261-4.336-2.024-.207-3.282 1.563-3.5 3.446-.223 1.875.601 3.86 2.734 4.074z"
              ></path>
              <g fill="#fff">
                <path d="M256.37-157.38c.977 0 1.77-.793 1.77-1.773 0-.977-.793-1.766-1.77-1.766s-1.77.79-1.77 1.766c0 .98.793 1.773 1.77 1.773z"></path>
                <path d="M229.35-158.88a1.768 1.768 0 100-3.535 1.767 1.767 0 100 3.535z"></path>
                <path d="M228.4-150.71a1.77 1.77 0 000-3.539 1.77 1.77 0 000 3.539z"></path>
                <path d="M256.3-149.56a1.77 1.77 0 000-3.539 1.77 1.77 0 000 3.539z"></path>
              </g>
            </g>
            <g fill="#edb92e" fillOpacity="1">
              <path
                strokeWidth="0.668"
                d="M133.71 208.48c-.406 1.336 2.555 3.435 2.504 3.93-1.695.657-5.742-.683-8.945-3.066-.528-1.618-1.567-1.763-3.977-2.099-.719-.097-.223-1.485 1.004-1.508 1.312-.027 2.043-.129 3.164.164.445.113.867.05 1.27-.442 1 2.52 2.222 3.138 4.98 3.021z"
                transform="matrix(0 1 .99969 0 0 0)"
              ></path>
              <path
                strokeLinejoin="round"
                strokeWidth="0.668"
                d="M123.33-207.28c.559.23 1.012.3 1.855.356.641.043 1.243-.196 1.774-.606.535-.414 1.008-1.004 1.39-1.665.239-.414.895-.887 1.641-1.258.742-.371 1.578-.64 2.176-.66 1.969-.051 3.687-.438 4.027-1.34.223-.587.188-.825.082-1.282-.355.129-.851.082-1.347.398-.637.41-1.368.77-2.004.801-.5.028-.832.262-1.809.07-.637-.124-.875-.539-1.46-.464-1.138.14-3.313 1.04-3.313 2.352-.004 1.297-.141 1.907-1.856 2.579-.582.226-.863.523-1.156.719z"
                transform="matrix(0 1 -.99969 0 0 0)"
              ></path>
              <path
                strokeWidth="0.663"
                d="M178.91-155.31c.385.215.835.345 1.252.434a3.178 3.178 0 002.08-.219c2.903-1.38 3.418-6.943-.117-7.72-.666.019-1.184.7-1.575 2.087-.434 1.816-.99 3.116-1.675 3.962-.388.685-.33 1.199.035 1.456z"
                transform="matrix(.99836 -.15239 -.15263 -1 0 0)"
              ></path>
              <path
                strokeWidth="0.662"
                d="M180.37-155.9c3.098.684 4.4-5.198 1.51-5.836-1.555-.345-1.418 1.498-1.546 2.552-.178 1.422-2.936 2.624.036 3.284z"
                transform="matrix(.99846 -.15241 -.15263 -1 0 0)"
              ></path>
            </g>
            <path
              fill="#0c4076"
              fillOpacity="1"
              strokeWidth="0.659"
              d="M180.28-156.77c1.508.332 2.957-3.276 1.06-3.756-1.28-.324-2.129.49-2.362 1.545-.237 1.06.243 1.978 1.302 2.211z"
              transform="matrix(.99998 -.15264 -.15264 -1 0 0)"
            ></path>
            <path
              fill="#edb92e"
              fillOpacity="1"
              strokeWidth="0.666"
              d="M-319.05-137.13l12.58 6.29 12.577-6.29-12.576-6.289z"
              transform="matrix(-.99997 -.06114 .06114 -1 0 0)"
            ></path>
            <path
              fill="#c6363c"
              fillOpacity="1"
              strokeWidth="0.666"
              d="M-133.9 306.46c0-3.125-1.698-5.658-3.79-5.66-2.095-.001-3.792 2.531-3.792 5.66 0 3.125 1.698 5.659 3.793 5.66 2.092.002 3.789-2.535 3.79-5.66z"
              transform="matrix(.06085 -.99538 1 .06112 0 0)"
            ></path>
            <path
              fill="#edb92e"
              fillOpacity="1"
              strokeWidth="0.667"
              d="M-325.33-151.57l13.176-4.988-10.879-7.278c-2.82.938-5.055 10.52-2.297 12.266z"
              transform="scale(-.99997 -1)"
            ></path>
            <path
              fill="#0c4076"
              fillOpacity="1"
              strokeWidth="0.667"
              d="M-325.08-154c3.113.32 5.813-1.105 6.024-3.184.21-2.078-2.145-4.02-5.258-4.336-2.028-.207-3.286 1.563-3.504 3.446-.22 1.875.601 3.86 2.738 4.074z"
              transform="scale(-.99997 -1)"
            ></path>
            <g fill="#fff" strokeWidth="0.667">
              <g transform="scale(-.99997 -1)">
                <path d="M-283.73-157.38c.977 0 1.774-.793 1.774-1.773a1.77 1.77 0 00-1.774-1.766c-.977 0-1.77.79-1.77 1.766 0 .98.793 1.773 1.77 1.773z"></path>
                <path d="M-310.74-158.88c.98 0 1.77-.79 1.77-1.77 0-.976-.79-1.765-1.77-1.765-.977 0-1.766.789-1.766 1.765 0 .981.79 1.77 1.766 1.77z"></path>
                <path d="M-311.7-150.71a1.77 1.77 0 000-3.539 1.77 1.77 0 000 3.539z"></path>
                <path d="M-283.79-149.56a1.77 1.77 0 000-3.539 1.77 1.77 0 000 3.539z"></path>
              </g>
              <path
                d="M224.57-101.96a3.532 3.532 0 003.527-3.531 3.53 3.53 0 00-3.527-3.527 3.532 3.532 0 00-3.531 3.527 3.533 3.533 0 003.531 3.531z"
                transform="scale(.99998 -1)"
              ></path>
              <path
                d="M221.99-96.098a3.53 3.53 0 000-7.058 3.53 3.53 0 000 7.058z"
                transform="scale(.99998 -1)"
              ></path>
              <path
                d="M230.44-75.449a3.403 3.403 0 10.006-6.807 3.403 3.403 0 00-.006 6.807z"
                transform="scale(.99997 -1)"
              ></path>
              <g transform="scale(.99998 -1)">
                <path d="M224.72-78.047a3.53 3.53 0 003.531-3.527 3.53 3.53 0 00-7.058 0 3.526 3.526 0 003.527 3.527z"></path>
                <path d="M220.51-83.031a3.528 3.528 0 000-7.058 3.53 3.53 0 100 7.058z"></path>
                <path d="M219.83-89.312a3.53 3.53 0 10-.004-7.058 3.53 3.53 0 00.004 7.058z"></path>
              </g>
            </g>
            <path
              fill="#edb92e"
              fillOpacity="1"
              strokeWidth="0.667"
              d="M271.77-49.832c.93.023 1.676.785 1.676 1.723 0 .937-.746 1.699-1.68 1.722a1.724 1.724 0 01-3.445 0 1.725 1.725 0 01-1.684-1.722c0-.938.75-1.7 1.68-1.723v-3.535h-3.043a1.723 1.723 0 01-3.446.031 1.725 1.725 0 01-1.718-1.723c0-.949.77-1.719 1.718-1.722a1.723 1.723 0 013.446-.04h3.043v-11.758h3.453v11.758h3.043c.047-.914.8-1.644 1.723-1.644.937 0 1.7.754 1.722 1.684.95.003 1.715.773 1.715 1.722 0 .95-.765 1.72-1.715 1.723a1.722 1.722 0 01-1.722 1.68 1.72 1.72 0 01-1.723-1.711h-3.043z"
              transform="scale(.99997 -1)"
            ></path>
            <path
              fill="#0c4076"
              fillOpacity="1"
              strokeWidth="0.667"
              d="M270.05-60.93c5.254 0 9.512-4.262 9.512-9.52a9.51 9.51 0 00-9.512-9.511c-5.254 0-9.516 4.258-9.516 9.511 0 5.258 4.262 9.52 9.516 9.52z"
              transform="scale(.99998 -1)"
            ></path>
            <path
              fill="#edb92e"
              fillOpacity="1"
              strokeWidth="0.667"
              d="M270.05-60.93c.59 0 1.164-.055 1.727-.156v-7.492h-3.454v7.492a9.688 9.688 0 001.727.156z"
              transform="scale(.99997 -1)"
            ></path>
            <g strokeWidth="0.667">
              <path
                fill="#edb92e"
                fillOpacity="1"
                d="M279.36-68.516a9.603 9.603 0 00.102-3.277c-3.13.105-6.262.18-9.419.18-3.156 0-6.289-.075-9.418-.18a9.6 9.6 0 00-.097 1.347c0 .66.07 1.309.195 1.93 3.098.11 6.2.18 9.32.18 3.122 0 6.223-.07 9.317-.18z"
                transform="scale(.99997 -1)"
              ></path>
              <path
                fill="#edb92e"
                fillOpacity="1"
                strokeLinejoin="round"
                d="M262.66-76.391c-2.016 1.238-2.367-.684-2.317-2.617.192-7.278 1.59-14.203-.37-23.117-.786-3.567-2.051-5.574-.82-6.262 3.144-1.75 4.585-3.355 4.085-4.219.93-1.77 3.246-1.426 6.805-.86 3.559-.565 5.875-.91 6.805.86-.5.864.941 2.47 4.082 4.22 1.234.687-.031 2.694-.816 6.26-1.961 8.915-.563 15.84-.372 23.118.047 1.933-.3 3.855-2.316 2.617-3.965-2.445-10.754-2.473-14.766 0z"
                transform="scale(.99997 -1)"
              ></path>
              <g fill="#fff" transform="scale(.99998 -1)">
                <path d="M270.05-103.79a3.782 3.782 0 10-.001-7.564 3.782 3.782 0 00.001 7.564z"></path>
                <path d="M270.05-97.234a3.782 3.782 0 10-3.781-3.781 3.784 3.784 0 003.781 3.781z"></path>
                <path d="M270.05-90.938a3.782 3.782 0 003.781-3.781 3.781 3.781 0 00-7.562 0 3.782 3.782 0 003.781 3.781z"></path>
                <path d="M270.05-73.043a3.781 3.781 0 003.781-3.777 3.782 3.782 0 00-7.562 0 3.781 3.781 0 003.781 3.777z"></path>
                <path d="M270.05-78.586a3.782 3.782 0 000-7.562 3.782 3.782 0 000 7.562z"></path>
                <path d="M270.05-84.637a3.782 3.782 0 003.781-3.781 3.781 3.781 0 00-7.562 0 3.782 3.782 0 003.781 3.781z"></path>
              </g>
            </g>
            <g fill="#edb92e" fillOpacity="1">
              <path
                strokeLinejoin="round"
                strokeWidth="0.496"
                d="M-194.18-91.497c2.278-.548 4.048-.547 5.31 0 2.857-4.88 7.763-9.826 14.821-14.801 1.023-.78 1.647-.912 1.969-.54.28.326-.031.958-1.1 1.974-3.723 2.92-7.05 5.39-9.513 7.89-2.2 2.232-3.643 4.52-5.278 7.085-.227.356-.66.353-2.198-.173-1.138-.385-2.118-.388-2.83-.046-.113-.304-.27-.426-.367-.487-.926-.58-1.162-.964-.814-.902z"
                transform="matrix(-.89741 -1 -.99997 .89744 0 0)"
              ></path>
              <path
                strokeLinejoin="round"
                strokeWidth="0.496"
                d="M74.296 207.66c2.276-.546 4.048-.547 5.31 0 2.857-4.88 7.763-9.826 14.821-14.801 1.022-.78 1.647-.912 1.969-.54.283.328-.031.958-1.101 1.976-3.722 2.918-7.048 5.388-9.512 7.888-2.2 2.232-3.641 4.522-5.278 7.085-.227.356-.66.353-2.198-.173-1.138-.385-2.118-.388-2.83-.046-.113-.304-.27-.426-.367-.487-.926-.58-1.162-.964-.814-.902z"
                transform="matrix(.89741 -1 .99997 .89744 0 0)"
              ></path>
              <path
                strokeWidth="0.667"
                d="M-273.91-110.68c-.545-.867-.4-1.04-.757-1.316-.46-.36-1.216-.364-1.938-.25-2.92.453-2.511-1.297-1.224-3.262.647-.984 2.146-1.973 2.93-2.817.781-.843.848-1.546 1.158-1.757a70.918 70.918 0 012.526-.024c.44-.008 1.405-.004 2.527.024.31.21.377.914 1.157 1.757.781.844 2.284 1.832 2.927 2.817 1.295 1.965 1.699 3.715-1.22 3.262-.726-.114-1.48-.11-1.938.25-.357.277-.212.449-.757 1.316-.353.563-.777.984-1.24 1.266-.463.28-.957.129-1.456.129-.494 0-.992.152-1.455-.13-.463-.28-.887-.703-1.24-1.265z"
                transform="scale(-.99567 -1)"
              ></path>
            </g>
          </g>
          <path
            fill="#21231e"
            d="M269.6 120.17l-.488-.07c-.262-2.078-1.094-3.797-2.399-5.297 1.47.992 2.559 3.12 2.887 5.367"
          ></path>
          <path
            fill="#21231e"
            d="M270.48 120.17l.492-.07c.258-2.078 1.09-3.797 2.395-5.297-1.465.992-2.559 3.12-2.887 5.367"
          ></path>
          <path
            fill="#edb92e"
            fillOpacity="1"
            stroke="#21231e"
            strokeMiterlimit="22.926"
            strokeOpacity="1"
            strokeWidth="0.667"
            d="M276.73-112.21c-.258-.633-.535-1.324-1.098-1.906-.855-.883-2.27-.309-3.64.836-.434.36-1.2.535-1.961.531-.762-.004-1.52-.184-1.938-.531-1.371-1.145-2.79-1.72-3.645-.836-.562.582-.836 1.273-1.093 1.906.332.059.761.055 1.32-.031.719-.113 1.473-.11 1.93.25.355.277.21.449.754 1.312.351.563.773.989 1.234 1.27.46.281.953.129 1.45.129.495 0 .988.152 1.449-.13.46-.28.882-.706 1.234-1.269.539-.863.398-1.035.754-1.312.457-.36 1.207-.363 1.93-.25.558.086.988.09 1.32.031z"
            transform="scale(.99997 -1)"
          ></path>
          <path
            fill="#edb92e"
            fillOpacity="1"
            stroke="#21231e"
            strokeMiterlimit="22.926"
            strokeOpacity="1"
            strokeWidth="0.667"
            d="M121.68-256.88c-.545-.867-.4-1.04-.757-1.316-.46-.36-1.216-.364-1.938-.25-2.919.453-2.51-1.293-1.22-3.258.643-.985 2.142-1.973 2.926-2.82.781-.844.848-1.543 1.158-1.754 1.118-.028 2.087-.032 2.526-.028h.004c.436-.004 1.404 0 2.523.028.31.21.376.91 1.16 1.754.781.847 2.28 1.835 2.923 2.82 1.291 1.965 1.7 3.71-1.22 3.258-.721-.114-1.475-.11-1.938.25-.357.277-.211.449-.757 1.316-.353.563-.777.988-1.24 1.266-.459.285-.957.129-1.455.129-.498 0-.992.156-1.455-.13-.46-.277-.887-.703-1.24-1.265z"
            transform="matrix(0 .99572 -1 0 0 0)"
          ></path>
          <path
            fill="#21231e"
            d="M266.37 124.29l-.074.488c-2.078.258-3.797 1.09-5.293 2.395.988-1.469 3.117-2.559 5.367-2.883"
          ></path>
          <path
            fill="#21231e"
            d="M266.37 123.4l-.074-.488c-2.078-.262-3.797-1.094-5.293-2.399.988 1.47 3.117 2.563 5.367 2.887"
          ></path>
          <path
            fill="#edb92e"
            fillOpacity="1"
            stroke="#21231e"
            strokeMiterlimit="22.926"
            strokeOpacity="1"
            strokeWidth="0.667"
            d="M-117.15-258.42c-.258-.633-.535-1.324-1.098-1.906-.855-.887-2.27-.313-3.644.832-.43.363-1.196.539-1.957.531-.762 0-1.52-.18-1.938-.531-1.37-1.145-2.789-1.719-3.644-.832-.563.582-.836 1.273-1.098 1.906.332.059.766.05 1.324-.035.72-.113 1.47-.11 1.926.25.36.277.215.449.758 1.316.351.563.773.985 1.234 1.266.457.285.953.129 1.45.129.496 0 .988.156 1.449-.13.457-.28.883-.702 1.234-1.265.54-.867.399-1.039.75-1.316.461-.36 1.211-.363 1.934-.25.554.086.988.094 1.32.035z"
            transform="matrix(0 -1 -.99997 0 0 0)"
          ></path>
          <path
            fill="#edb92e"
            fillOpacity="1"
            stroke="#21231e"
            strokeMiterlimit="22.926"
            strokeOpacity="1"
            strokeWidth="0.667"
            d="M-127.07 283.2c-.545-.867-.4-1.04-.757-1.316-.463-.36-1.216-.364-1.938-.25-2.919.453-2.51-1.297-1.22-3.262.643-.98 2.142-1.973 2.926-2.817.781-.843.848-1.546 1.158-1.757 1.118-.024 2.087-.031 2.526-.024h.004c.436-.008 1.404 0 2.523.024.31.21.376.914 1.157 1.758.784.843 2.283 1.835 2.926 2.816 1.291 1.965 1.7 3.715-1.22 3.262-.721-.114-1.479-.11-1.938.25-.357.277-.211.449-.757 1.316-.353.563-.777.984-1.24 1.266-.458.28-.957.129-1.455.129-.498 0-.996.152-1.455-.13-.463-.28-.887-.703-1.24-1.265z"
            transform="matrix(0 -.99572 1 0 0 0)"
          ></path>
          <path
            fill="#21231e"
            d="M273.71 123.4l.074-.488c2.078-.262 3.793-1.094 5.293-2.399-.988 1.47-3.117 2.563-5.367 2.887"
          ></path>
          <path
            fill="#21231e"
            d="M273.71 124.29l.074.488c2.078.258 3.793 1.09 5.293 2.395-.988-1.469-3.117-2.559-5.367-2.883"
          ></path>
          <g
            fillOpacity="1"
            stroke="#21231e"
            strokeMiterlimit="22.926"
            strokeOpacity="1"
            strokeWidth="0.667"
          >
            <g fill="#edb92e">
              <path
                d="M130.53 281.67c-.258-.633-.535-1.32-1.098-1.902-.855-.887-2.273-.313-3.644.832-.43.363-1.195.535-1.957.53-.762 0-1.52-.179-1.938-.53-1.375-1.145-2.789-1.72-3.644-.832-.563.582-.84 1.27-1.098 1.902.332.059.766.055 1.32-.031.723-.113 1.473-.11 1.934.25.352.277.21.449.75 1.316.352.563.777.985 1.234 1.266.461.281.954.129 1.45.129s.992.152 1.449-.13c.46-.28.883-.702 1.234-1.265.543-.867.399-1.039.758-1.316.457-.36 1.207-.363 1.926-.25.558.086.992.09 1.324.031z"
                transform="matrix(0 1 .99997 0 0 0)"
              ></path>
              <g transform="scale(.99998 -1)">
                <path d="M270.05-119.56a4.286 4.286 0 004.285-4.281 4.29 4.29 0 00-4.285-4.29 4.288 4.288 0 00-4.285 4.29 4.284 4.284 0 004.285 4.281z"></path>
                <path d="M270.04-120.69a3.15 3.15 0 000-6.3 3.15 3.15 0 000 6.3z"></path>
              </g>
            </g>
            <path
              fill="#0c4076"
              d="M270.05-121.86a1.984 1.984 0 001.984-1.98 1.985 1.985 0 00-3.968 0c0 1.093.886 1.98 1.984 1.98z"
              transform="scale(.99998 -1)"
            ></path>
          </g>
          <path
            fill="#21231e"
            d="M202.9 127.59l.375-.16c-.852-1.184-1.035-2.313-.71-3.445-.727.898-.552 2.312.335 3.605"
          ></path>
          <path
            fill="#edb92e"
            fillOpacity="1"
            stroke="#21231e"
            strokeMiterlimit="22.926"
            strokeOpacity="1"
            strokeWidth="0.667"
            d="M230.47-113.1c.738-.926.648-1.148 1.047-1.414.523-.344 1.23-.227 1.887.023 2.691 1.024 2.695-1.101 1.91-3.535-.379-1.18-1.528-2.46-2.04-3.465-.503-.98-.394-1.719-.62-1.969a62.12 62.12 0 00-2.196-.324h-.004a53.336 53.336 0 00-2.168-.265c-.312.175-.554.875-1.441 1.644-.899.766-2.442 1.602-3.274 2.543-1.687 1.914-2.586 3.746.067 3.684.664-.016 1.324.101 1.617.574.234.367.059.535.285 1.61.149.706.41 1.269.746 1.675.34.41.836.32 1.293.406.461.086.88.356 1.391.098.508-.254 1.023-.68 1.5-1.285z"
            transform="scale(.99997 -1)"
          ></path>
          <path
            fill="#21231e"
            d="M230.08 123.84c-.145-.004-.29-.012-.438-.02-.757-2.109-1.94-3.812-3.496-5.246 1.563.868 3.082 2.98 3.934 5.266"
          ></path>
          <path
            fill="#21231e"
            d="M230.85 123.73l.41-.129c-.277-2.195.04-4.144.852-5.988-1.086 1.308-1.531 3.746-1.262 6.117"
          ></path>
          <path
            fill="#edb92e"
            fillOpacity="1"
            stroke="#21231e"
            strokeMiterlimit="22.926"
            strokeOpacity="1"
            strokeWidth="0.667"
            d="M234.66-114.23c-.098-.781-.2-1.625-.594-2.375-.59-1.129-2.039-.695-3.594.383-.488.34-1.234.418-1.925.297-.688-.121-1.32-.434-1.598-.887-.883-1.453-1.945-2.266-2.942-1.438-.66.551-1.105 1.258-1.523 1.915.27.113.644.171 1.156.16.664-.016 1.325.101 1.617.574.235.367.059.531.286 1.61.152.706.41 1.265.746 1.675.34.41.836.317 1.293.402.46.086.879.36 1.39.106.508-.258 1.024-.684 1.5-1.29.739-.925.645-1.148 1.047-1.417.524-.34 1.23-.219 1.887.027.508.192.922.274 1.254.258z"
            transform="scale(.99997 -1)"
          ></path>
          <path
            fill="#edb92e"
            fillOpacity="1"
            stroke="#21231e"
            strokeMiterlimit="22.926"
            strokeOpacity="1"
            strokeWidth="0.675"
            d="M219.95-125.32c.43.518.602.404.68.73.097.423-.153 1.086-.473 1.714-1.293 2.526.082 2.31 1.945 1.318.473-.251 1.024-.702 1.567-1.165.547-.463 1.094-.95 1.547-1.279.925-.663 1.496-.683 1.765-.95.41-1.023.746-1.913.89-2.31v-.004c.161-.4.493-1.286.856-2.306-.058-.287-.59-.365-.984-1.098-.395-.714-.7-2.017-1.176-2.644-.7-.922-1.344-1.471-1.84-1.381-.5.09-.851.816-.988 2.42-.05.624-.406 1.287-.816 1.675-.325.306-.395.177-1.192.62a5.25 5.25 0 00-1.3 1.036c-.348.38-.399.811-.563 1.239-.16.428-.43.847-.387 1.251.04.412.192.8.469 1.134z"
            transform="scale(1 -.99584)"
          ></path>
          <path
            fill="#21231e"
            d="M228.12 127.52c.04.18.086.352.125.52-.8.187-1.465.515-2.016.964-.554.45-.996 1.028-1.343 1.723.12-.77.507-1.457 1.07-2.008.562-.55 1.312-.968 2.164-1.199"
          ></path>
          <path
            fill="#21231e"
            d="M227.8 126.6c-.078-.172-.16-.34-.242-.512a8.22 8.22 0 01-2.594-.664c-.836-.36-1.656-.855-2.465-1.469.64.715 1.477 1.32 2.39 1.774.927.46 1.938.765 2.911.87"
          ></path>
          <path
            fill="#edb92e"
            fillOpacity="1"
            stroke="#21231e"
            strokeLinejoin="round"
            strokeMiterlimit="22.926"
            strokeOpacity="1"
            strokeWidth="0.667"
            d="M219.74-120.74c.55-.203.918-.453 1.55-.973.485-.394.747-.968.84-1.62.094-.657.02-1.403-.163-2.137-.114-.457.027-1.239.296-2.004.27-.762.676-1.52 1.086-1.926 1.356-1.348 2.305-2.774 1.926-3.652-.246-.579-.433-.727-.82-.989-.16.328-.547.625-.68 1.18-.168.723-.437 1.473-.867 1.922-.332.348-.406.742-1.23 1.254-.536.328-.989.187-1.348.629-.703.859-1.625 2.957-.727 3.918.89.945 1.207 1.48.457 3.105-.254.555-.246.957-.32 1.293z"
            transform="scale(.99997 -1)"
          ></path>
          <path
            fill="#edb92e"
            fillOpacity="1"
            stroke="#21231e"
            strokeMiterlimit="22.926"
            strokeOpacity="1"
            strokeWidth="0.634"
            d="M-187.65 182.9c-.342-.817-.18-.945-.452-1.228-.351-.367-1.026-.463-1.693-.464-2.627.005-1.945-1.38-.467-2.834.734-.724 2.221-1.366 3.056-1.964.836-.605 1.014-1.165 1.326-1.303 1.009.083 1.891.169 2.29.22l.002-.005c.407.038 1.303.131 2.354.267.259.205.217.793.84 1.588.631.8 1.963 1.832 2.473 2.773 1.037 1.928 1.211 3.586-1.71 2.734-.705-.208-1.457-.31-1.962-.058-.397.196-.281.37-.954 1.063a3.82 3.82 0 01-1.414.947c-.495.18-.943-.035-1.417-.11-.473-.078-.967-.018-1.35-.337a3.34 3.34 0 01-.923-1.286z"
            transform="matrix(-.3224 -.9955 1 -.32386 0 0)"
          ></path>
          <path
            fill="#21231e"
            d="M234.43 125.58c-.012-.156-.027-.316-.04-.477 1.778-.484 3.157-1.5 4.282-2.988-.633 1.59-2.332 2.902-4.242 3.465"
          ></path>
          <path
            fill="#21231e"
            d="M234.61 126.41c.055.152.105.305.16.453 1.86.035 3.531.649 5.094 1.73-1.14-1.288-3.227-2.105-5.254-2.183"
          ></path>
          <g stroke="#21231e" strokeMiterlimit="22.926" strokeOpacity="1">
            <g fill="#edb92e" fillOpacity="1">
              <path
                strokeWidth="0.677"
                d="M242.63-132.12c-.598.185-1.258.38-1.863.844-.922.715-.653 2.092.136 3.514.254.455.286 1.22.153 1.97-.133.754-.426 1.492-.824 1.873-1.301 1.248-2.094 2.63-1.438 3.639.445.68 1.043 1.068 1.594 1.44.12-.345.195-.812.21-1.413.024-.773.157-1.558.575-1.982.324-.334.46-.161 1.371-.609.59-.29 1.063-.671 1.402-1.107.34-.435.27-.954.344-1.452.078-.495.297-.978.102-1.46a3.488 3.488 0 00-.992-1.34c-.708-.612-.887-.49-1.086-.855-.25-.471-.13-1.178.086-1.845.164-.507.238-.907.23-1.217z"
                transform="scale(1 -.99504)"
              ></path>
              <g strokeWidth="0.667" transform="scale(.99997 -1)">
                <path d="M230.37-122.2c2.234.105 4.387-1.832 4.703-4.203.317-2.371-1.242-4.211-3.383-4.238-2.14-.02-4.125 1.714-4.535 4.003-.406 2.286.985 4.325 3.215 4.438z"></path>
                <path d="M230.56-123.36c1.629.07 3.195-1.332 3.434-3.066.242-1.735-.88-3.11-2.47-3.133-1.57-.028-3.058 1.285-3.347 2.957-.297 1.707.75 3.172 2.383 3.242z"></path>
              </g>
            </g>
            <path
              fill="#0c4076"
              fillOpacity="1"
              strokeWidth="0.667"
              d="M230.74-124.55c1.02.043 1.996-.828 2.156-1.918.157-1.086-.547-1.96-1.547-1.98-1-.024-1.937.8-2.117 1.87-.18 1.067.489 1.993 1.508 2.028z"
              transform="scale(.99997 -1)"
            ></path>
            <g fill="#fff" strokeWidth="0.667">
              <path
                d="M-312.8-107.74a3.526 3.526 0 003.527-3.527 3.53 3.53 0 00-7.059 0 3.53 3.53 0 003.532 3.527z"
                transform="scale(-.99998 -1)"
              ></path>
              <g transform="scale(-.99997 -1)">
                <path d="M-342.86-115.13a3.276 3.276 0 003.273-3.277 3.276 3.276 0 10-6.55 0 3.277 3.277 0 003.277 3.277z"></path>
                <path d="M-345.99-109.14a3.277 3.277 0 10.001-6.553 3.277 3.277 0 00-.001 6.553z"></path>
                <path d="M-348.94-103.09a3.277 3.277 0 10.001-6.556 3.277 3.277 0 00-.001 6.556z"></path>
              </g>
            </g>
            <path
              fill="#edb92e"
              fillOpacity="1"
              strokeWidth="0.667"
              d="M-297.62-94.248c1.896-.003 1.202-3.323.778-4.049-.549-.943-1.002-.94-1.556 0-.42.724-1.114 4.048.778 4.045z"
              transform="matrix(-.99925 -.06748 .06753 -1 0 0)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0.665"
              d="M-297.4-96.068c4.453-.004 2.82-7.808 1.83-9.506-1.297-2.213-2.36-2.216-3.66 0-.994 1.697-2.62 9.506 1.83 9.506z"
              transform="matrix(-.99997 -.06753 .06753 -1 0 0)"
            ></path>
            <path
              fill="#edb92e"
              fillOpacity="1"
              strokeWidth="0.637"
              d="M-331.4-13.715c1.81.002 1.15-3.175.743-3.865-.525-.9-.958-.899-1.485 0-.406.69-1.065 3.861.742 3.865z"
              transform="matrix(-.99924 -.31799 .3182 -1 0 0)"
            ></path>
            <path
              fill="#fff"
              strokeWidth="0.635"
              d="M-331.16-15.455c4.25 0 2.694-7.455 1.749-9.076-1.24-2.117-2.256-2.118-3.497 0-.95 1.618-2.502 9.077 1.748 9.076z"
              transform="matrix(-.99997 -.31822 .31821 -1 0 0)"
            ></path>
            <g strokeWidth="0.667" transform="scale(-.99997 -1)">
              <path
                fill="#edb92e"
                fillOpacity="1"
                strokeLinejoin="round"
                d="M-279.99-78.922c-9.551.863-19.317-.11-28.985-3.945-8.149-3.235-7.348-12.68 2.586-25.793-.898-1.66-1.41-3.723-1.488-6.11 1.05.059 1.785.031 2.715.055-.72 1.586.085 3.531.996 4.902.593.899.71.739-.004 1.739-5.914 8.246-9.833 15.469-7.528 19.832 2.801 5.3 13.664 8.062 31.99 7.656-.036.484-.071.972-.102 1.465-.059.066-.118.132-.18.199z"
              ></path>
              <g fill="#fff">
                <path d="M-326.32-81.609a3.402 3.402 0 100-6.805 3.402 3.402 0 000 6.805z"></path>
                <path d="M-319.66-79.43a3.402 3.402 0 100-6.805 3.402 3.402 0 000 6.805z"></path>
              </g>
            </g>
            <g fill="#edb92e" fillOpacity="1">
              <path
                strokeWidth="0.667"
                d="M-318.77-82.332c.336-.45.676-.898 1.02-1.352-5.375-2.949-7.602-6.058-7.079-9.183.09-.54 1.727-6.262 5.375-17.355 2.497-1.723 4.356-3.27 5.583-4.63-.141-.151.394-.636.234-.769.371-1.695-1.54-1.351-2.82-.93-.618 1.626-2.504 3.356-3.586 4.094-.223.149-1.02.54-1.098.793-1.957 6.243-3.918 12.016-5.602 17.391-1.691 5.403 1.973 9.227 7.973 11.941z"
                transform="scale(-.99997 -1)"
              ></path>
              <path
                strokeLinejoin="round"
                strokeWidth="0.665"
                d="M-346.69-98.926l-.28-1.07c-1.58-.253-2.92-.256-4.015.002 1.977 1.678 3.38 1.97 4.295 1.068z"
                transform="matrix(-.99997 -.0678 .0678 -1 0 0)"
              ></path>
              <path
                strokeWidth="0.668"
                d="M119.94 340.26c.219-.98.383-1.075.457-1.5.094-.551.055-1.31-.402-1.83-1.274-2.129 1.023-2.176 2.742-1.347 1.246.601 2.656.293 3.723-.282 1.261-.672 1.835-.527 2.175-.05.22.332.422.644.602.93.676.57.559 1.008-.324 1.09-.875 2.121-2.91 2.825-4.703 3.462-2.621.93-3.243 4.306-4.27-.473z"
                transform="matrix(0 1 .99966 0 0 0)"
              ></path>
              <path
                strokeWidth="0.667"
                d="M-339.93-120.03c1.851-.656 2.058.367 3.307.316-.49-2.828-.99-4.293-3.949-2.777-1.628.84-3.717-.387-4.113-1.297-.145-.332-1.095.36-1.444 1.117-1.452 3.168 3.714 3.524 6.199 2.641z"
                transform="scale(-.99818 -1)"
              ></path>
            </g>
            <g fill="#fff" strokeWidth="0.667">
              <g transform="scale(-.99998 -1)">
                <path d="M-282.96-71.613a3.387 3.387 0 100-6.774 3.387 3.387 0 000 6.774z"></path>
                <path d="M-289.9-71.613a3.387 3.387 0 100-6.774 3.387 3.387 0 000 6.774z"></path>
                <path d="M-296.84-72.16a3.383 3.383 0 003.387-3.387 3.39 3.39 0 00-6.777 0 3.387 3.387 0 003.39 3.387z"></path>
                <path d="M-303.24-73.383c1.871 0 3.39-1.52 3.39-3.39a3.39 3.39 0 10-3.39 3.39z"></path>
              </g>
              <g transform="scale(-.99997 -1)">
                <path d="M-345.33-90.836a3.402 3.402 0 100-6.805 3.402 3.402 0 000 6.805z"></path>
                <path d="M-339.5-87.16a3.403 3.403 0 10-3.402-3.402 3.405 3.405 0 003.402 3.402z"></path>
                <path d="M-332.87-84.051a3.402 3.402 0 10-3.402-3.398 3.402 3.402 0 003.402 3.398z"></path>
                <path d="M-349.85-96.367a3.403 3.403 0 10.006-6.807 3.403 3.403 0 00-.006 6.807z"></path>
              </g>
            </g>
            <g fill="#edb92e" fillOpacity="1">
              <path
                strokeWidth="0.668"
                d="M133.71-331.77c-.406 1.34 2.555 3.435 2.504 3.93-1.695.661-5.742-.683-8.945-3.066-.528-1.614-1.567-1.763-3.977-2.095-.719-.102-.223-1.489 1.004-1.512 1.312-.028 2.043-.13 3.164.164.445.117.867.055 1.27-.442 1 2.52 2.222 3.142 4.98 3.021z"
                transform="matrix(0 1 -.99969 0 0 0)"
              ></path>
              <path
                strokeLinejoin="round"
                strokeWidth="0.668"
                d="M123.33 332.97c.559.234 1.012.305 1.855.36.641.042 1.243-.196 1.774-.606.535-.414 1.008-1.004 1.39-1.669.239-.41.895-.883 1.641-1.254.742-.371 1.578-.645 2.176-.66 1.969-.051 3.687-.438 4.027-1.34.223-.59.188-.825.082-1.282-.355.125-.851.078-1.347.398-.637.41-1.368.77-2.004.801-.5.028-.832.262-1.809.07-.637-.124-.875-.543-1.46-.468-1.138.144-3.313 1.04-3.313 2.356-.004 1.297-.141 1.907-1.856 2.575-.582.23-.863.527-1.156.719z"
                transform="matrix(0 1 .99969 0 0 0)"
              ></path>
              <path
                strokeWidth="0.663"
                d="M-349.74-74.75c.389.214.835.345 1.252.434a3.179 3.179 0 002.08-.219c2.903-1.376 3.418-6.943-.113-7.721-.67.02-1.188.7-1.578 2.088-.435 1.816-.991 3.116-1.676 3.962-.388.684-.33 1.199.035 1.456z"
                transform="matrix(-.99836 -.15239 .15263 -1 0 0)"
              ></path>
              <path
                strokeWidth="0.662"
                d="M-348.22-75.338c3.098.688 4.402-5.194 1.507-5.831-1.555-.345-1.415 1.493-1.547 2.548-.174 1.425-2.936 2.627.04 3.283z"
                transform="matrix(-.99846 -.15241 .15263 -1 0 0)"
              ></path>
            </g>
            <path
              fill="#0c4076"
              fillOpacity="1"
              strokeWidth="0.659"
              d="M-347.51-76.211c1.508.336 2.957-3.276 1.06-3.756-1.28-.324-2.133.49-2.362 1.545-.237 1.06.243 1.978 1.302 2.211z"
              transform="matrix(-.99998 -.15264 .15264 -1 0 0)"
            ></path>
            <g fill="#fff" strokeWidth="0.667">
              <path
                d="M-315.52-101.96a3.53 3.53 0 10-.004-7.058 3.53 3.53 0 00.004 7.058z"
                transform="scale(-.99998 -1)"
              ></path>
              <path
                d="M-318.1-96.098a3.528 3.528 0 003.523-3.531 3.525 3.525 0 00-3.523-3.527 3.53 3.53 0 100 7.058z"
                transform="scale(-.99998 -1)"
              ></path>
              <path
                d="M-309.65-75.449a3.402 3.402 0 100-6.805 3.402 3.402 0 000 6.805z"
                transform="scale(-.99997 -1)"
              ></path>
              <g transform="scale(-.99998 -1)">
                <path d="M-315.37-78.047a3.527 3.527 0 100-7.055 3.528 3.528 0 000 7.055z"></path>
                <path d="M-319.58-83.031a3.53 3.53 0 10-.004-7.058 3.53 3.53 0 00.004 7.058z"></path>
                <path d="M-320.26-89.312a3.53 3.53 0 10-.004-7.058 3.53 3.53 0 00.004 7.058z"></path>
              </g>
            </g>
          </g>
          <path
            fill="#21231e"
            d="M337.18 127.59l-.379-.16c.856-1.184 1.04-2.313.715-3.445.726.898.547 2.312-.336 3.605"
          ></path>
          <path
            fill="#edb92e"
            fillOpacity="1"
            stroke="#21231e"
            strokeMiterlimit="22.926"
            strokeOpacity="1"
            strokeWidth="0.667"
            d="M-309.61-113.1c.734-.926.645-1.148 1.043-1.414.523-.344 1.23-.227 1.887.023 2.691 1.024 2.695-1.101 1.914-3.535-.383-1.18-1.531-2.46-2.043-3.465-.5-.98-.395-1.719-.617-1.969-.98-.16-1.817-.277-2.2-.324h-.004a52.901 52.901 0 00-2.164-.265c-.316.175-.558.875-1.445 1.644-.895.766-2.442 1.602-3.274 2.543-1.687 1.914-2.586 3.746.07 3.684.66-.016 1.321.101 1.618.574.23.367.055.535.281 1.61.149.706.41 1.269.746 1.675.34.41.836.32 1.293.406.461.086.88.356 1.391.098.508-.254 1.023-.68 1.5-1.285z"
            transform="scale(-.99997 -1)"
          ></path>
          <path
            fill="#21231e"
            d="M309.99 123.84c.148-.004.293-.012.441-.02.758-2.109 1.938-3.812 3.493-5.246-1.559.868-3.082 2.98-3.934 5.266"
          ></path>
          <path
            fill="#21231e"
            d="M309.23 123.73l-.41-.129c.277-2.195-.04-4.144-.852-5.988 1.086 1.308 1.531 3.746 1.262 6.117"
          ></path>
          <path
            fill="#edb92e"
            fillOpacity="1"
            stroke="#21231e"
            strokeMiterlimit="22.926"
            strokeOpacity="1"
            strokeWidth="0.667"
            d="M-305.43-114.23c-.098-.781-.2-1.625-.594-2.375-.59-1.129-2.039-.695-3.59.383-.492.34-1.238.418-1.93.297-.687-.121-1.32-.434-1.593-.887-.887-1.453-1.95-2.266-2.942-1.438-.66.551-1.11 1.258-1.527 1.915.27.113.644.171 1.16.16.66-.016 1.32.101 1.617.574.23.367.055.531.285 1.61.149.706.407 1.265.743 1.675.34.41.836.317 1.293.402.46.086.879.36 1.39.106.508-.258 1.024-.684 1.504-1.29.735-.925.645-1.148 1.047-1.417.52-.34 1.227-.219 1.883.027.508.192.922.274 1.254.258z"
            transform="scale(-.99997 -1)"
          ></path>
          <path
            fill="#edb92e"
            fillOpacity="1"
            stroke="#21231e"
            strokeMiterlimit="22.926"
            strokeOpacity="1"
            strokeWidth="0.675"
            d="M-320.12-125.32c.426.518.598.404.676.73.101.423-.149 1.086-.473 1.714-1.293 2.526.082 2.31 1.945 1.318.473-.251 1.024-.702 1.567-1.165.547-.463 1.094-.95 1.55-1.279.926-.663 1.493-.683 1.762-.95.41-1.023.75-1.913.89-2.31l.005-.004c.156-.4.488-1.286.855-2.306-.062-.287-.59-.365-.988-1.098-.39-.714-.7-2.017-1.176-2.644-.703-.922-1.34-1.471-1.84-1.381-.496.09-.851.816-.984 2.42-.055.624-.41 1.287-.824 1.675-.32.306-.39.177-1.188.62a5.25 5.25 0 00-1.3 1.036c-.344.38-.399.811-.559 1.239-.164.428-.434.847-.39 1.251.039.412.195.8.468 1.134z"
            transform="scale(-1 -.99584)"
          ></path>
          <path
            fill="#21231e"
            d="M311.95 127.52c-.04.18-.082.352-.121.52.8.187 1.465.515 2.016.964.554.45.996 1.028 1.343 1.723-.12-.77-.507-1.457-1.07-2.008-.562-.55-1.312-.968-2.168-1.199"
          ></path>
          <path
            fill="#21231e"
            d="M312.28 126.6c.078-.172.156-.34.238-.512a8.27 8.27 0 002.598-.664c.836-.36 1.652-.855 2.465-1.469-.64.715-1.477 1.32-2.395 1.774a8.706 8.706 0 01-2.906.87"
          ></path>
          <path
            fill="#edb92e"
            fillOpacity="1"
            stroke="#21231e"
            strokeLinejoin="round"
            strokeMiterlimit="22.926"
            strokeOpacity="1"
            strokeWidth="0.667"
            d="M-320.36-120.74c.55-.203.918-.453 1.55-.973.485-.394.747-.968.84-1.62.094-.657.024-1.403-.16-2.137-.117-.457.024-1.239.293-2.004.274-.762.676-1.52 1.086-1.926 1.356-1.348 2.305-2.774 1.93-3.652-.25-.579-.437-.727-.824-.989-.16.328-.547.625-.68 1.18-.164.723-.437 1.473-.863 1.922-.336.348-.406.742-1.234 1.254-.532.328-.985.187-1.348.629-.703.859-1.625 2.957-.727 3.918.89.945 1.211 1.48.457 3.105-.254.555-.246.957-.32 1.293z"
            transform="scale(-.99997 -1)"
          ></path>
          <path
            fill="#edb92e"
            fillOpacity="1"
            stroke="#21231e"
            strokeMiterlimit="22.926"
            strokeOpacity="1"
            strokeWidth="0.634"
            d="M-28.632-305.91c-.342-.817-.18-.945-.456-1.229-.349-.362-1.021-.466-1.69-.463-2.628 0-1.947-1.382-.47-2.835.734-.724 2.225-1.365 3.06-1.966.837-.606 1.014-1.162 1.326-1.3 1.01.08 1.891.169 2.292.216.404.036 1.303.131 2.35.266.26.2.22.793.843 1.584.632.805 1.966 1.833 2.47 2.777 1.04 1.929 1.216 3.587-1.705 2.735-.706-.208-1.456-.313-1.963-.058-.397.196-.281.37-.953 1.06-.437.452-.921.769-1.415.95-.495.18-.946-.036-1.42-.114-.469-.077-.967-.016-1.35-.334a3.37 3.37 0 01-.92-1.289z"
            transform="matrix(.3224 -.9955 -1 -.32386 0 0)"
          ></path>
          <path
            fill="#21231e"
            d="M305.64 125.58c.012-.156.027-.316.035-.477-1.777-.484-3.152-1.5-4.277-2.988.633 1.59 2.332 2.902 4.242 3.465"
          ></path>
          <path
            fill="#21231e"
            d="M305.46 126.41c-.055.152-.105.305-.16.453-1.863.035-3.531.649-5.094 1.73 1.14-1.288 3.227-2.105 5.254-2.183"
          ></path>
          <g
            fillOpacity="1"
            stroke="#21231e"
            strokeMiterlimit="22.926"
            strokeOpacity="1"
          >
            <path
              fill="#edb92e"
              strokeWidth="0.677"
              d="M-297.45-132.12c-.602.185-1.262.38-1.863.844-.926.715-.657 2.092.136 3.514.254.455.282 1.22.153 1.97-.133.754-.43 1.492-.828 1.873-1.301 1.248-2.094 2.63-1.434 3.643.441.675 1.043 1.064 1.594 1.437.117-.346.191-.813.207-1.414.023-.773.16-1.558.574-1.982.324-.334.461-.161 1.371-.609.59-.29 1.063-.67 1.402-1.107.34-.435.27-.954.348-1.452.074-.495.297-.978.098-1.46a3.516 3.516 0 00-.988-1.34c-.711-.612-.887-.49-1.086-.855-.25-.471-.133-1.178.082-1.845.164-.506.238-.907.234-1.217z"
              transform="scale(-1 -.99504)"
            ></path>
            <g strokeWidth="0.667" transform="scale(.99997 -1)">
              <path
                fill="#edb92e"
                d="M309.72-122.2c-2.234.105-4.39-1.832-4.703-4.203-.317-2.371 1.242-4.211 3.379-4.238 2.14-.02 4.129 1.714 4.539 4.003.406 2.286-.984 4.325-3.215 4.438z"
              ></path>
              <path
                fill="#edb92e"
                d="M309.54-123.36c-1.633.07-3.195-1.332-3.438-3.066-.238-1.735.88-3.11 2.473-3.133 1.57-.028 3.059 1.285 3.348 2.957.297 1.707-.75 3.172-2.383 3.242z"
              ></path>
              <path
                fill="#0c4076"
                d="M309.35-124.55c-1.02.043-1.992-.828-2.152-1.918-.16-1.086.546-1.96 1.547-1.98 1-.024 1.937.8 2.117 1.87.18 1.067-.489 1.993-1.512 2.028z"
              ></path>
              <path
                fill="#edb92e"
                d="M322.58-164.62c1.11-.168 1.695-.863 1.656-1.574.04-.715-.547-1.41-1.66-1.574a4.59 4.59 0 00-.848-.149c-33.688-2.879-69.678-2.879-103.37 0a4.703 4.703 0 00-.847.149c-1.11.164-1.696.859-1.657 1.574-.039.71.547 1.406 1.657 1.574.254.066.535.117.847.145 33.688 2.882 69.678 2.882 103.37 0a5.07 5.07 0 00.852-.145z"
              ></path>
            </g>
          </g>
        </g>
        <g strokeMiterlimit="22.926">
          <path
            fill="none"
            stroke="#21231e"
            strokeLinecap="round"
            strokeOpacity="1"
            strokeWidth="0.67"
            d="M231.26-167.68c4.3.27 8.61.495 12.914.671 4.309.18 8.617.31 12.926.397a617.667 617.667 0 0025.868-.02c4.309-.09 8.621-.228 12.926-.408 4.309-.177 8.617-.4 12.922-.667"
            transform="scale(1 -.99502)"
          ></path>
          <path
            fill="none"
            stroke="#21231e"
            strokeLinecap="round"
            strokeOpacity="1"
            strokeWidth="0.67"
            d="M231.26 167.79c4.3.27 8.61.495 12.914.671m51.719-.031c4.309-.18 8.617-.404 12.922-.667"
            transform="scale(1 .99502)"
          ></path>
          <path
            fill="#c6363c"
            fillOpacity="1"
            stroke="#fff"
            strokeWidth="1.334"
            d="M168.74 175.52H321.8c27.389 0 52.257 10.613 70.28 27.734 18.019 17.121 29.193 40.75 29.193 66.777v.004c0 26.027-11.174 49.656-29.193 66.777-18.023 17.121-42.891 27.734-70.284 27.734h-153.06z"
            transform="matrix(0 .99807 1 0 0 0)"
          ></path>
          <g stroke="#21231e" strokeOpacity="1">
            <g fillRule="evenodd">
              <g fill="#fff">
                <path
                  strokeWidth="0.667"
                  d="M413.43 270.9c-.137.816.035 2.207-.787 3.25-1.096 1.395-5.523.844-8.322.719-14.307-.645-38.389-1.23-72.21-1.957-.16-1.188-.078-2.059.047-2.871-.125-.817-.207-1.684-.047-2.875 33.821-.727 57.902-1.313 72.21-1.953 2.799-.125 7.226-.676 8.322.714.822 1.047.65 2.434.787 3.254z"
                  transform="matrix(0 .99791 1 0 0 0)"
                ></path>
                <path
                  strokeWidth="0.667"
                  d="M-279.86-412.16c.828.059 2.195-.242 3.313.484 1.484.961 1.609 5.477 1.734 8.274.656 14.273 1.98 38.19 4.313 71.867-1.172.273-2.043.265-2.864.219-.129.03-.262.058-.39.09-5.376-33.317-7.403-56.95-11.082-71.204-.508-1.968-1.602-6.902.097-8.504.969-.91 2.364-.863 3.172-1.074z"
                  transform="scale(-.99997 -1)"
                ></path>
                <path
                  strokeWidth="0.667"
                  d="M-290.38-410.66c.832-.016 2.164-.434 3.344.184 1.566.824 1.504 5.335 2.203 8.043 3.68 14.258 5.707 37.898 11.082 71.223-1.14.375-2.008.449-2.832.476l-.117.04c-8.543-32.396-11.106-55.235-17.74-69.34-.613-1.954-2.284-7.145-.687-8.954.883-1 2.278-1.078 3.059-1.36z"
                  transform="scale(-.99997 -1)"
                ></path>
                <path
                  strokeWidth="0.641"
                  d="M457.44-169.53c-.13.79.214 2.284-.578 3.291-1.055 1.337-5.584.294-8.227.714-14.89 2.386-36.836-1.365-69.335-2.066-.155-1.143-.075-1.979.045-2.76-.119-.781-.319-.698-.164-1.845 32.499-.697 54.113 2.252 69.509-2.794 2.486-.816 6.945-.653 7.998.69.79 1.004.626 2.335.754 3.126z"
                  transform="matrix(.28733 .9979 -1 .28794 0 0)"
                ></path>
                <path
                  strokeWidth="0.667"
                  d="M260.23-412.16c.828.059 2.192-.242 3.309.484 1.488.961 1.61 5.477 1.738 8.274.656 14.273 1.98 38.19 4.313 71.867-1.172.273-2.043.265-2.868.219-.125.03-.258.058-.386.09-5.376-33.317-7.403-56.95-11.082-71.204-.512-1.968-1.602-6.902.097-8.504.969-.91 2.364-.863 3.168-1.074z"
                  transform="scale(.99997 -1)"
                ></path>
                <path
                  strokeWidth="0.667"
                  d="M249.71-410.66c.832-.016 2.164-.434 3.34.184 1.57.824 1.508 5.335 2.207 8.043 3.68 14.258 5.707 37.898 11.082 71.223-1.14.375-2.008.449-2.832.476l-.117.04c-8.547-32.396-11.106-55.235-17.74-69.34-.613-1.954-2.288-7.145-.687-8.954.883-1 2.278-1.078 3.059-1.36z"
                  transform="scale(.99997 -1)"
                ></path>
                <path
                  strokeWidth="0.641"
                  d="M313.54 329.19c-.13.79.21 2.283-.581 3.29-1.056 1.337-5.585.294-8.227.714-14.89 2.386-36.836-1.365-69.336-2.063-.155-1.146-.075-1.978.045-2.76-.119-.784-.319-.701-.165-1.844 32.5-.701 54.115 2.248 69.51-2.798 2.486-.813 6.945-.653 7.998.689.79 1.004.626 2.336.754 3.127z"
                  transform="matrix(-.28733 .9979 1 .28794 0 0)"
                ></path>
                <path
                  strokeWidth="0.607"
                  d="M-431.77 99.917c.247-.642.296-1.76 1.22-2.53 1.225-1.023 5.246-.23 7.825.09 13.603-.566 35.556 3.239 66.652 7.252-.033.962-.24 1.646-.478 2.284a6.584 6.584 0 01-.39 2.292c-31.105-3.24-52.469-8.047-67.243-4.142-2.44.646-6.802-.028-7.606-1.224-.606-.9-.24-1.991-.238-2.654z"
                  transform="matrix(-.45267 -.99325 1 -.45577 0 0)"
                ></path>
                <path
                  strokeWidth="0.638"
                  d="M-432.56 156.24c.225-.694.217-1.88 1.128-2.722 1.214-1.118 5.408-.38 8.087-.098 13.687 1.424 36.786 3.395 69.233 6.094.02 1.022-.158 1.753-.37 2.44.026.703.01 1.444-.283 2.45-32.615-1.458-55.834-6.524-69.679-2.77-2.521.685-7.03.133-7.923-1.117-.676-.946-.35-2.114-.387-2.82z"
                  transform="matrix(-.30182 -.99916 1 -.30208 0 0)"
                ></path>
                <path
                  strokeWidth="0.659"
                  d="M-419.09 215.03c.184-.726.097-1.962.976-2.865 1.175-1.198 5.52-.56 8.286-.351 14.123 1.054 37.923 2.387 71.358 4.181.086 1.064-.049 1.83-.224 2.549.074.73.102 1.503-.135 2.554-33.521-.5-57.7-1.495-71.6-.71-2.767.157-7.195.358-8.193-.917-.751-.956-.492-2.183-.576-2.918z"
                  transform="matrix(-.15041 -.99831 1 -.15066 0 0)"
                ></path>
                <path
                  strokeWidth="0.607"
                  d="M-226.57-347.27c.249-.645.296-1.76 1.22-2.53 1.225-1.023 5.244-.235 7.821.088 13.606-.564 35.556 3.24 66.656 7.251-.029.963-.24 1.645-.476 2.288-.01.656-.061 1.352-.392 2.288-31.107-3.242-52.472-8.046-67.243-4.139-2.438.643-6.801-.031-7.609-1.229-.605-.9-.235-1.99-.237-2.654z"
                  transform="matrix(.45267 -.99325 -1 -.45577 0 0)"
                ></path>
                <path
                  strokeWidth="0.638"
                  d="M-282.93-338.67c.22-.691.213-1.881 1.124-2.723 1.214-1.118 5.412-.379 8.087-.098 13.69 1.425 36.785 3.399 69.233 6.094.024 1.023-.158 1.753-.37 2.443.026.7.01 1.44-.283 2.446-32.615-1.457-55.834-6.523-69.679-2.769-2.52.685-7.03.136-7.923-1.117-.673-.942-.346-2.113-.386-2.82z"
                  transform="matrix(.30182 -.99916 -1 -.30208 0 0)"
                ></path>
                <path
                  strokeWidth="0.659"
                  d="M-339.39-313.06c.183-.722.096-1.958.976-2.865 1.171-1.199 5.52-.557 8.286-.351 14.119 1.053 37.922 2.391 71.354 4.181.09 1.064-.05 1.832-.221 2.553.074.73.102 1.5-.135 2.554-33.521-.5-57.7-1.495-71.6-.71-2.77.153-7.195.358-8.192-.917-.751-.96-.496-2.184-.577-2.918z"
                  transform="matrix(.15041 -.99831 -1 -.15066 0 0)"
                ></path>
                <path
                  strokeWidth="0.667"
                  d="M388.99 270.81c-.138.738.04 1.988-.79 2.934-1.102 1.257-5.551.757-8.367.648-14.373-.582-38.573-1.11-72.564-1.762-.162-1.078-.08-1.86.047-2.593-.126-.735-.209-1.52-.047-2.594 33.99-.653 58.19-1.184 72.564-1.762 2.816-.113 7.265-.61 8.366.648.83.946.653 2.196.791 2.934z"
                  transform="matrix(0 .99304 1 0 0 0)"
                ></path>
                <path
                  strokeWidth="0.647"
                  d="M410.59-187.12c-.097.558.13 1.492-.619 2.219-.992.967-5.27.674-7.969.641-13.681 1.704-36.925.528-69.513.006-.205-.803-.163-1.39-.078-1.947-.152-.55-.274-1.136-.169-1.947 32.406-.123 55.298 1.943 69.343-2.662 2.319-.756 6.922-.593 8.035.331.837.697.729 1.641.895 2.195z"
                  transform="matrix(.25239 1 -.993 .25064 0 0)"
                ></path>
                <path
                  strokeWidth="0.658"
                  d="M403.25-216.37c-.109.56.106 1.506-.678 2.232-1.036.966-5.423.645-8.19.595-14.134-.257-37.908-.353-71.3-.418-.197-.814-.142-1.407-.045-1.965-.143-.555-.252-1.147-.128-1.963 33.347-.926 57.778 1.618 71.18-2.25 2.442-.702 7.112-.553 8.236.386.845.702.714 1.653.872 2.21z"
                  transform="matrix(.16491 .99501 -1 .16573 0 0)"
                ></path>
                <path
                  strokeWidth="0.665"
                  d="M386.89-244.45c-.125.568.07 1.521-.732 2.245-1.07.97-5.483.616-8.274.547-14.242-.348-38.214-.596-71.875-.88-.183-.817-.11-1.416-.002-1.977-.133-.562-.23-1.156-.087-1.98 33.641-.72 57.957-.75 71.819-1.815 2.763-.211 7.18-.513 8.29.442.836.717.687 1.673.837 2.236z"
                  transform="matrix(.08204 .99884 -1 .08214 0 0)"
                ></path>
                <path
                  strokeWidth="0.647"
                  d="M282.43 324.19c-.093.559.133 1.497-.616 2.223-.995.963-5.273.67-7.972.637-13.682 1.708-36.925.528-69.511.011-.208-.808-.162-1.394-.078-1.947-.155-.55-.273-1.14-.168-1.95 32.406-.123 55.298 1.942 69.342-2.659 2.316-.76 6.919-.594 8.03.33.839.693.735 1.638.897 2.191z"
                  transform="matrix(-.25239 1 .993 .25064 0 0)"
                ></path>
                <path
                  strokeWidth="0.658"
                  d="M315.69 309.26c-.106.565.106 1.51-.674 2.233-1.04.965-5.423.644-8.19.594-14.137-.257-37.913-.35-71.302-.418-.198-.814-.14-1.406-.042-1.964-.147-.556-.257-1.148-.129-1.963 33.343-.923 57.778 1.618 71.181-2.25 2.441-.702 7.108-.554 8.232.381.844.71.714 1.657.872 2.214z"
                  transform="matrix(-.16491 .99501 1 .16573 0 0)"
                ></path>
                <path
                  strokeWidth="0.665"
                  d="M342.78 292.01c-.125.564.07 1.521-.732 2.245-1.07.97-5.483.616-8.27.548-14.25-.35-38.218-.597-71.882-.882-.179-.82-.11-1.415.002-1.976-.137-.563-.233-1.16-.087-1.98 33.64-.72 57.957-.75 71.819-1.815 2.763-.211 7.18-.513 8.29.442.836.717.684 1.67.833 2.236z"
                  transform="matrix(-.08204 .99884 1 .08214 0 0)"
                ></path>
                <path
                  strokeWidth="0.667"
                  d="M366.65 270.67c-.137.566.035 1.524-.785 2.25-1.094.961-5.512.578-8.309.493-14.277-.442-38.305-.848-72.055-1.352-.164-.82-.082-1.422.043-1.985-.125-.562-.207-1.16-.043-1.984 33.75-.5 57.777-.907 72.055-1.348 2.797-.09 7.215-.473 8.309.492.82.723.648 1.68.785 2.25z"
                  transform="matrix(0 1 .99988 0 0 0)"
                ></path>
              </g>
              <g fill="#edb92e" fillOpacity="1">
                <path
                  strokeLinejoin="round"
                  strokeWidth="0.662"
                  d="M352.36 188.11c-.139-1.788.617-4.094 5.396-11.142 5.37-3.475 10.773-6.973 15.253-11.438.713-1.426 1.199-2.535 1.416-3.624.23-1.133-1.014-9.147-1.378-9.302-2.583-2.228-1.423-6.25 1.138-5.262.823-1.104 4.543.663 3.325 2.591-1.123 1.768.804 7.228.35 9.177 1.604-.912 2.087-6.11 1.915-9.684-.253-3.25 3.014-3.425 5.663-2.393 1.155 1.4-.222.304.553.77 2.334 1.187 2.428 4.32.333 4.678-2.168.37-4.093 8.27-5.63 9.604 3.146-1.785 5.852-5.353 8.9-7.33 1.51-1.912 1.73-2.985 5.463-1.2.019 2.478-.618 2.7.996 4.032.039 3.386-.893 4.05-3.616 3.826-2.878-.235-7.668 2.713-9.008 3.667-1.236.875-2.588 1.218-3.33 2.014-1.296 1.387-3.476 7.509-2.503 8.891 1.785 2.551 1.16 4.732-1.448 5.394-.788-.796-4.467.319-4.858-1.548-.315-1.525.05-2.495 1.038-4.051 1.558-2.45 2.39-3.71 2.1-4.42-.695-1.679-2.507 3.496-7.822 8.648-7.366 7.137-11.434 8.057-14.246 8.102z"
                  transform="matrix(.12042 .99535 1 -.12098 0 0)"
                ></path>
                <path
                  strokeWidth="0.659"
                  d="M376.71 136.23c-1.628-2.021-1.77-3.297-.935-4.301.46-.553.094-1.112-.686-.635-3.256 1.992-3.336 4.403-1.391 6.267.635.506 1.176.91 1.717 1.313.47-.43.937-2.297 1.295-2.644z"
                  transform="matrix(.15013 .99966 1 -.15019 0 0)"
                ></path>
                <path
                  strokeWidth="0.65"
                  d="M383.63-143.53c-1.066-2.65-.91-4.88.22-5.876.621-.545.412-1.266-.51-.865-3.86 1.672-4.628 4.44-3.196 6.966.497.708.926 1.28 1.358 1.853.944-.558 2.174-1.966 2.128-2.078z"
                  transform="matrix(.21494 1 -.99442 .21375 0 0)"
                ></path>
                <path
                  strokeWidth="0.659"
                  d="M-144.65 395.59c1.885 2.62 2.95 4.45 2.562 6.073-.223.949.318 1.704 1.1.785 3.179-3.715 2.622-7.32-.11-9.4-.91-.695-1.828-1.09-2.666-1.569-.815 1.041-.98 3.985-.886 4.11z"
                  transform="matrix(-.9986 .15606 .15628 1 0 0)"
                ></path>
                <path
                  strokeWidth="0.614"
                  d="M381.15 35.172c-.024-2.224.698-3.296 2.032-3.784.736-.266.803-.853-.145-.763-6.36-.032-6.342 2.793-4.67 6.173 1.018-.201 2.782-1.528 2.783-1.626z"
                  transform="matrix(.42431 .99781 1 -.42524 0 0)"
                ></path>
              </g>
            </g>
            <g fill="none">
              <path
                strokeWidth="0.493"
                d="M-84.106-292.84c-.264 1.228.21 1.747.749 1.855 1.144.228 1.197-.545 1.283-2.005"
                transform="matrix(.91227 -1 -.99998 -.91229 0 0)"
              ></path>
              <path
                strokeWidth="0.493"
                d="M-82.027-292.85c-.264 1.228.21 1.747.749 1.855 1.142.226 1.197-.545 1.283-2.005"
                transform="matrix(.91227 -1 -.99998 -.91229 0 0)"
              ></path>
              <path
                strokeWidth="0.674"
                d="M-347.23-220.91c1.11 1.627 2.344 1.725 3.176 1.297 1.754-.901.91-1.81-.711-3.512"
                transform="matrix(0 -1 -.99656 0 0 0)"
              ></path>
              <path
                strokeWidth="0.677"
                d="M-344.76-223.55c1.258 1.727 2.648 1.833 3.59 1.378 1.984-.958 1.027-1.928-.805-3.737"
                transform="matrix(0 -1 -.99509 0 0 0)"
              ></path>
              <path
                strokeWidth="0.669"
                d="M-342.14-225.14c1.332 1.603 2.652 2.104 3.813 1.373 1.816-1.146 1.09-1.92-.856-3.723"
                transform="matrix(0 -1 -.99883 0 0 0)"
              ></path>
            </g>
            <g fillRule="evenodd">
              <path
                fill="#edb92e"
                fillOpacity="1"
                strokeLinejoin="round"
                strokeWidth="0.655"
                d="M-275.11 146.01c.918 1.18 4.565 1.907 9.5 3.203 7.997 1.855 13.133.338 15.173-4.607-3.727 3.002-7.676 4.079-11.572 2.267-5.254-2.444-8.223-4.04-9.53-4.045-.906.136-2.444 1.43-3.572 3.182z"
                transform="matrix(-.99998 -.19529 -.19528 1 0 0)"
              ></path>
              <g fill="#fff" strokeWidth="0.667">
                <path
                  d="M265.95-313.66a644.116 644.116 0 01-.094-7.836l-.023-.008-5.973-1.238c-.016-2.723 6.719-31.211 10.188-31.211 3.469 0 10.2 28.508 10.188 31.23l-5.973 1.219-.023.008c-.02 2.757-.05 5.441-.094 7.835-1.254-1.043-2.64-2.855-4.098-4.496-1.46 1.641-2.843 3.453-4.097 4.496z"
                  transform="scale(.99997 -1)"
                ></path>
                <g strokeLinejoin="round">
                  <path
                    d="M329.69 253.93l-3.11-5.304c1.579-2.274 7.548-4.034 12.505-.263 6.178 4.701 10.633 6.574 15.59 7.669-4.41 3.56-9.085 4.836-13.7 2.688-6.225-2.892-9.739-4.787-11.285-4.79z"
                    transform="matrix(.01547 1 .99997 -.01547 0 0)"
                  ></path>
                  <path
                    d="M325.48 258.37l-3.11-5.304c1.579-2.278 7.313-7.07 12.27-3.299 6.174 4.702 10.867 9.61 15.826 10.705-4.41 3.56-9.081 5.121-13.696 2.974-6.22-2.892-9.739-5.072-11.29-5.076z"
                    transform="matrix(.01547 1 .99997 -.01547 0 0)"
                  ></path>
                  <path
                    d="M321.33-286.03l-3.11-5.304c1.582-2.278 7.551-4.034 12.509-.263 6.178 4.697 10.629 6.574 15.59 7.669-4.41 3.56-9.089 4.832-13.7 2.685-6.225-2.893-9.738-4.784-11.29-4.787z"
                    transform="matrix(-.01547 1 -.99997 -.01547 0 0)"
                  ></path>
                  <path
                    d="M317.12-281.59l-3.106-5.308c1.579-2.274 7.31-7.07 12.265-3.299 6.179 4.702 10.871 9.61 15.83 10.71-4.41 3.556-9.08 5.116-13.696 2.969-6.224-2.892-9.742-5.072-11.293-5.072z"
                    transform="matrix(-.01547 1 -.99997 -.01547 0 0)"
                  ></path>
                  <path
                    d="M323.13 246.59l-3.11-5.304c1.583-2.274 7.552-4.034 12.509-.26 6.178 4.698 10.633 6.575 15.59 7.67-4.41 3.556-9.089 4.832-13.7 2.684-6.225-2.896-9.739-4.787-11.29-4.79z"
                    transform="matrix(.01547 1 .99997 -.01547 0 0)"
                  ></path>
                  <path
                    d="M314.77-293.37l-3.11-5.308c1.583-2.274 7.548-4.03 12.509-.26 6.178 4.702 10.629 6.575 15.587 7.67-4.406 3.556-9.086 4.832-13.701 2.685-6.225-2.892-9.739-4.787-11.285-4.787z"
                    transform="matrix(-.01547 1 -.99997 -.01547 0 0)"
                  ></path>
                </g>
                <g transform="matrix(0 .99513 1 0 0 0)">
                  <path d="M264.2 226.8c4.91.102 37.66-.766 42.288-1.04 4.608-.269 7.749-2.304 9.55-4.476-2.743-1.988-6.445-3.175-10.842-3.457-2.237-.148-33.228.266-39.599.438-9.707 3.656-10.076 6.367-1.397 8.535z"></path>
                  <path d="M256.19 205.58l45.028-1.383c3.996-.437 27.764 4.746 32.455 7.578-3.01 7.016-19.136 8.496-34.849 7.176-15.717-1.316-29.287.223-32.109 1.293-3.556.094-7.266-.5-10.967-.535.27-4.469.173-9.66.444-14.13z"></path>
                  <path d="M263.55 197.27l45.043.95c4.012-.227 27.466 6.183 31.988 9.257-5.535 7.113-28.18 5.684-35.03 4.594-13.652-2.172-29.468-1.805-32.035-1.055-3.556-.09-7.811-.183-11.509-.41l1.543-13.336z"></path>
                  <path d="M274.22 191.1l-.302 11.797c4.914-1.004 20.176-.203 31.807 1.832 10.909 1.91 39.195 4.574 45.986-6.746-14.924-7.016-29.428-1.672-42.39-5.211-13.774-2.762-25.275-3.305-35.101-1.672z"></path>
                  <path d="M255.93 236.2c4.915-.047 37.621-1.902 42.237-2.313 4.597-.414 7.67-2.543 9.397-4.765-2.802-1.906-6.54-2.98-10.94-3.133-2.245-.074-33.208 1.273-39.572 1.637-9.585 3.945-9.868 6.668-1.122 8.574z"></path>
                  <path d="M229.25 215.24c10.547-.316 33.444-.496 35.387-.43 4.4.149 9.998 1.88 12.805 3.786-1.727 2.222-4.8 4.347-9.401 4.761-3.776.336-22.34.457-31.642.512-1.535-2.375-3.455-4.832-5.5-6.813 0 0-1.558-1.746-1.648-1.816z"></path>
                  <path d="M236.05 223.66c11.368-.21 29.275-.086 30.728-.035 4.4.148 8.141 1.222 10.948 3.129-1.731 2.222-4.915 4.57-9.511 4.98-2.83.254-14.963 1.04-24.278 1.11-.95-2.989-5.869-6.762-7.886-9.184z"></path>
                  <path d="M228.3 216.41l-11.615-8.031c5.731-1.621 46.833-3.602 50.201-1.278 4.4.149 8.126 1.731 10.932 3.637-1.731 2.223-4.844 5.543-9.495 4.582-4.652-.957-35.226.117-40.023 1.09z"></path>
                  <path d="M254.15 199.95c6.36-.363 10.665-.621 12.907-.543 4.4.148 8.141 1.223 10.948 3.129-1.731 2.223-4.797 5.055-9.405 4.762-17.798-1.121-34.563.82-50.68 3.078-1.405-1.906-2.917-5.117-4.322-7.024 21.703-3.808 35.175-5.082 40.553-3.402z"></path>
                  <path
                    strokeLinejoin="round"
                    d="M265.8 191.91l8.279 2.18c4.4.148 8.035 2.86 10.842 4.761-1.735 2.223-4.577 4.243-9.154 3.676-26.292-3.258-43.685-2.094-65.11 3.403 8.514-12.43 26.473-18.192 55.143-14.02z"
                  ></path>
                  <path d="M273.94 192.55l-3.8-11.406c11.442-1.45 25.813.781 44.765 3.856 16.271 2.636 29.15 1.25 37.413-.766-1.672 12.168-17.413 17.312-47.018 11.21-7.748-1.597-17.652-3.202-31.36-2.894z"></path>
                </g>
              </g>
            </g>
            <path
              fill="none"
              strokeLinecap="round"
              strokeWidth="0.667"
              d="M192.21-327.71c.266 7.543-1 15.777-2.434 22.715-1.972 9.512-2.984 18.629-3.047 28.207"
              transform="scale(.99997 -1)"
            ></path>
            <g fillRule="evenodd">
              <g fill="#fff">
                <path
                  strokeLinejoin="round"
                  strokeWidth="0.667"
                  d="M206.63-192.1l1.264-7.484c1.61.367 11.493 2.265 13.177 2.613 13.735 2.797 29.919 4.644 47.67 2.527 6.587-.785 11.972-2.176 16.137-4.219-.938 8.211-8.981 13.473-23.01 12.793-16.388 1.43-29.421.801-39.218-1.843-2.873-.774-13.699-3.266-16.019-4.387z"
                  transform="matrix(0 .99513 -1 0 0 0)"
                ></path>
                <path
                  strokeWidth="0.667"
                  d="M208.41-187.56l4.208-3.676c.75 1.043 3.976-.726 10.245.227 3.556.613 7.753 2.726 12.294 3.16 15.046 1.45 33.888 1.453 45.935-3.055-.938 8.211-8.404 11.031-22.449 11.297-11.615.219-25.307.258-41.114-2.648-3.694-.59-6.642-2.36-9.119-5.305z"
                  transform="matrix(0 .99513 -1 0 0 0)"
                ></path>
                <path
                  strokeWidth="0.588"
                  d="M83.473 252.63l2.47-6.26c6.152 1.89 10.535 3.167 12.628 4.023 4.107 1.684 7.043 4.771 8.98 7.54-2.476 1.474-5.88.954-10.38-.272-4.522-1.238-9.037-3.352-13.699-5.031z"
                  transform="matrix(-.5338 .99821 1 .53476 0 0)"
                ></path>
                <path
                  strokeWidth="0.665"
                  d="M248.95 211.52l-.368-6.703c6.145-.63 10.303-1.065 12.482-1.098 4.272-.063 7.948.764 10.765 2.404-1.563 2.145-4.436 4.266-8.869 4.86-4.452.594-9.255.27-14.01.537z"
                  transform="matrix(.06514 .99756 1 -.0653 0 0)"
                ></path>
                <path
                  strokeWidth="0.664"
                  d="M259.33 209.01l-.364-6.686c6.128-.626 10.274-1.064 12.444-1.094 4.258-.063 7.928.76 10.736 2.398-1.562 2.137-4.42 4.25-8.84 4.846-4.443.593-9.23.268-13.975.536z"
                  transform="matrix(.10014 .99756 1 -.10039 0 0)"
                ></path>
                <path
                  strokeWidth="0.667"
                  d="M228.04 224.51l-.367-6.713c6.158-.633 10.323-1.07 12.505-1.106 4.281-.06 7.965.767 10.79 2.41-1.57 2.15-4.443 4.273-8.885 4.87-4.462.597-9.277.27-14.043.539z"
                  transform="matrix(-.0159 .99757 1 .01593 0 0)"
                ></path>
                <path
                  strokeWidth="0.667"
                  d="M217.06 221.67l-2.813-7.451c5.014-1.087 21.44-2.25 28.254.987-1.742 2.392-4.947 4.76-9.897 5.424-4.97.666-10.234.74-15.544 1.04z"
                  transform="matrix(-.03259 .99785 1 .03266 0 0)"
                ></path>
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="0.674"
                  d="M197.43 222.2l2.002-11.649c6.915-2.145 12.993-3.422 18.44-3.836-1.405 5.36-4.387 9.084-9.354 10.096-6.698 1.366-9.85 4.487-11.088 5.389zm0 0"
                  transform="matrix(-.0827 1 .99547 .08232 0 0)"
                ></path>
              </g>
              <g fill="#edb92e" fillOpacity="1">
                <g strokeWidth="0.663">
                  <path
                    d="M-216.79 510.25c-4.492 4.658-8.602-5.995-4.617-20.081 2.945-10.42 17.352-6.375 9.328 7.646-.379.663-.918.35-.84-.405.453-2.876-.96-4.542-3.144-4.016-5.97 1.449-6.157 16.107.332 12.77 1.187-.096.125 2.856-1.059 4.087z"
                    transform="scale(-1 .77147)"
                  ></path>
                  <path
                    d="M231.53 510.25c-4.492 4.658-8.602-5.995-4.617-20.081 2.949-10.42 17.352-6.375 9.328 7.646-.383.663-.914.35-.84-.405.457-2.876-.96-4.542-3.144-4.016-5.965 1.449-6.153 16.107.332 12.77 1.183-.096.125 2.856-1.059 4.087z"
                    transform="scale(1 .77147)"
                  ></path>
                  <path
                    d="M223.73-464.99l-.004-.096c-.586-2.446-2.77-5.499-4.465-7.793-2.633-3.554-2.011-8.937-.187-11.798 1.984-3.119 2.87-6.633 3.27-9.367.3-1.68.831-5.453.445-11.317-.192-2.886-1.54-4.375-2.805-5.666-.64-.658.273-2.228 2.394-4.294.235-.222.871-.79 1.176-2.217.117-.345 1.102-.345 1.219 0 .305 1.428.941 1.995 1.176 2.217 2.12 2.066 3.035 3.636 2.394 4.294-1.265 1.291-2.613 2.78-2.804 5.666-.387 5.863.148 9.636.44 11.317.403 2.734 1.29 6.248 3.278 9.367 1.82 2.861 2.446 8.244-.187 11.798-1.7 2.294-3.883 5.347-4.47 7.793v.096c-.03.476-.233.714-.437.714-.203 0-.406-.238-.433-.714z"
                    transform="scale(1 -.77147)"
                  ></path>
                </g>
                <path
                  strokeWidth="0.667"
                  d="M458.1 220.92v6.492c0 1.117 1.07 2.031 2.372 2.031 1.306 0 2.371-.914 2.371-2.03v-6.493c0-1.117-1.065-2.031-2.371-2.031-1.302 0-2.372.914-2.372 2.031z"
                  transform="matrix(0 .84 1 0 0 0)"
                ></path>
                <g strokeWidth="0.663">
                  <path
                    d="M-308.54 510.25c-4.488 4.658-8.598-5.995-4.617-20.081 2.949-10.42 17.355-6.375 9.332 7.646-.383.663-.918.35-.844-.405.457-2.876-.96-4.542-3.14-4.016-5.97 1.449-6.157 16.107.331 12.77 1.184-.096.125 2.856-1.062 4.087z"
                    transform="scale(-1 .77147)"
                  ></path>
                  <path
                    d="M323.28 510.25c-4.492 4.658-8.602-5.995-4.617-20.081 2.945-10.42 17.352-6.375 9.328 7.646-.379.663-.914.35-.84-.405.457-2.876-.96-4.542-3.144-4.016-5.965 1.449-6.153 16.107.335 12.77 1.184-.096.122 2.856-1.062 4.087z"
                    transform="scale(1 .77147)"
                  ></path>
                  <path
                    d="M315.47-464.99l-.004-.096c-.586-2.446-2.77-5.499-4.465-7.793-2.633-3.554-2.011-8.937-.187-11.798 1.984-3.119 2.875-6.633 3.27-9.367.3-1.68.831-5.453.445-11.317-.192-2.886-1.54-4.375-2.805-5.666-.64-.658.273-2.228 2.394-4.294.235-.222.871-.79 1.176-2.217.117-.345 1.102-.345 1.219 0 .305 1.428.945 1.995 1.176 2.217 2.12 2.066 3.035 3.636 2.394 4.294-1.261 1.291-2.613 2.78-2.804 5.666-.387 5.863.148 9.636.445 11.317.398 2.734 1.285 6.248 3.273 9.367 1.82 2.861 2.442 8.244-.187 11.798-1.7 2.294-3.883 5.347-4.47 7.793v.096c-.03.476-.233.714-.437.714-.203 0-.406-.238-.433-.714z"
                    transform="scale(1 -.77147)"
                  ></path>
                </g>
                <path
                  strokeWidth="0.667"
                  d="M458.1 312.67v6.492c0 1.117 1.07 2.028 2.372 2.028 1.306 0 2.371-.91 2.371-2.028v-6.492c0-1.117-1.065-2.031-2.371-2.031-1.302 0-2.372.914-2.372 2.031z"
                  transform="matrix(0 .84 1 0 0 0)"
                ></path>
              </g>
              <g
                fill="#fff"
                strokeWidth="0.667"
                transform="matrix(0 .99513 -1 0 0 0)"
              >
                <path d="M264.2-313.28c4.91.102 37.66-.762 42.288-1.035 4.608-.274 7.749-2.309 9.55-4.48-2.743-1.989-6.445-3.176-10.842-3.458-2.237-.144-33.228.266-39.599.438-9.707 3.656-10.076 6.367-1.397 8.535z"></path>
                <path d="M256.19-334.5l45.028-1.387c3.996-.437 27.764 4.75 32.455 7.582-3.01 7.016-19.136 8.496-34.849 7.176-15.717-1.32-29.287.219-32.109 1.29-3.556.093-7.266-.5-10.967-.536.27-4.469.173-9.66.444-14.125z"></path>
                <path d="M263.55-342.81l45.043.953c4.012-.23 27.466 6.184 31.988 9.254-5.535 7.113-28.18 5.684-35.03 4.594-13.652-2.172-29.468-1.805-32.035-1.055-3.556-.09-7.811-.18-11.509-.406l1.543-13.34z"></path>
                <path d="M274.22-348.98l-.302 11.793c4.914-1.004 20.176-.2 31.807 1.836 10.909 1.906 39.195 4.57 45.986-6.746-14.924-7.02-29.428-1.676-42.39-5.215-13.774-2.758-25.28-3.305-35.101-1.668z"></path>
                <path d="M255.93-303.88c4.915-.043 37.621-1.902 42.237-2.313 4.597-.414 7.67-2.543 9.397-4.765-2.802-1.906-6.54-2.98-10.94-3.129-2.245-.078-33.208 1.27-39.572 1.633-9.585 3.945-9.868 6.668-1.122 8.574z"></path>
                <path d="M229.25-324.84c10.547-.316 33.444-.496 35.387-.43 4.4.153 9.998 1.88 12.805 3.786-1.727 2.222-4.8 4.351-9.401 4.761-3.776.336-22.34.457-31.642.516-1.535-2.38-3.455-4.832-5.5-6.813 0 0-1.558-1.75-1.648-1.82z"></path>
                <path d="M236.05-316.41c11.368-.207 29.275-.086 30.728-.035 4.4.148 8.141 1.222 10.948 3.129-1.731 2.222-4.915 4.57-9.511 4.98-2.83.254-14.963 1.04-24.278 1.114-.95-2.989-5.869-6.766-7.886-9.188z"></path>
                <path d="M228.3-323.66l-11.615-8.027c5.731-1.625 46.833-3.606 50.201-1.282 4.4.149 8.126 1.735 10.932 3.641-1.731 2.223-4.844 5.54-9.495 4.578-4.652-.957-35.226.117-40.023 1.09z"></path>
                <path d="M254.15-340.13c6.36-.36 10.665-.621 12.907-.543 4.4.148 8.141 1.223 10.948 3.129-1.731 2.223-4.797 5.055-9.405 4.766-17.798-1.122-34.563.816-50.68 3.074-1.405-1.906-2.917-5.117-4.322-7.024 21.703-3.808 35.175-5.082 40.553-3.402z"></path>
                <path
                  strokeLinejoin="round"
                  d="M265.8-348.16l8.279 2.18c4.4.152 8.035 2.86 10.842 4.761-1.735 2.227-4.577 4.243-9.154 3.676-26.292-3.258-43.685-2.094-65.11 3.406 8.514-12.434 26.473-18.195 55.143-14.023z"
                ></path>
                <path d="M273.94-347.52l-3.8-11.406c11.442-1.453 25.813.781 44.765 3.852 16.271 2.636 29.15 1.25 37.413-.766-1.672 12.168-17.413 17.312-47.018 11.211-7.748-1.594-17.652-3.2-31.36-2.89z"></path>
              </g>
            </g>
            <path
              fill="none"
              strokeLinecap="round"
              strokeWidth="0.667"
              d="M-347.88-327.71c.266 7.543-.996 15.777-2.434 22.715-1.968 9.512-2.984 18.629-3.047 28.207"
              transform="scale(-.99997 -1)"
            ></path>
            <g fillRule="evenodd">
              <g fill="#fff">
                <path
                  strokeLinejoin="round"
                  strokeWidth="0.667"
                  d="M206.63 347.98l1.264-7.488c1.61.37 11.493 2.27 13.177 2.613 13.735 2.8 29.919 4.648 47.67 2.531 6.587-.785 11.972-2.18 16.137-4.219-.938 8.211-8.981 13.473-23.01 12.793-16.388 1.426-29.421.801-39.218-1.843-2.873-.774-13.699-3.266-16.019-4.387z"
                  transform="matrix(0 .99513 1 0 0 0)"
                ></path>
                <path
                  strokeWidth="0.667"
                  d="M208.41 352.52l4.208-3.68c.75 1.047 3.976-.722 10.245.227 3.556.617 7.753 2.726 12.294 3.164 15.046 1.45 33.888 1.453 45.935-3.055-.938 8.211-8.404 11.031-22.449 11.297-11.615.219-25.307.258-41.114-2.648-3.694-.59-6.642-2.36-9.119-5.305z"
                  transform="matrix(0 .99513 1 0 0 0)"
                ></path>
                <path
                  strokeWidth="0.588"
                  d="M308.46-167.35l2.47-6.26c6.152 1.89 10.535 3.167 12.63 4.027 4.104 1.683 7.042 4.767 8.979 7.536-2.477 1.474-5.88.954-10.381-.272-4.524-1.235-9.037-3.351-13.698-5.031z"
                  transform="matrix(.5338 .99821 -1 .53476 0 0)"
                ></path>
                <path
                  strokeWidth="0.665"
                  d="M213.74-326.26l-.368-6.703c6.145-.63 10.303-1.07 12.478-1.101 4.272-.064 7.948.763 10.769 2.404-1.563 2.144-4.436 4.265-8.869 4.858-4.452.595-9.255.271-14.01.542z"
                  transform="matrix(-.06514 .99756 -1 -.0653 0 0)"
                ></path>
                <path
                  strokeWidth="0.664"
                  d="M205.52-325.68l-.367-6.686c6.127-.625 10.274-1.06 12.448-1.094 4.254-.063 7.923.761 10.732 2.398-1.559 2.14-4.42 4.251-8.84 4.846-4.44.593-9.23.268-13.972.536z"
                  transform="matrix(-.10014 .99756 -1 -.10039 0 0)"
                ></path>
                <path
                  strokeWidth="0.667"
                  d="M236.66-315.43l-.37-6.717c6.161-.628 10.327-1.07 12.509-1.102 4.277-.065 7.964.767 10.789 2.41-1.57 2.147-4.443 4.273-8.885 4.867-4.462.6-9.277.274-14.043.542z"
                  transform="matrix(.0159 .99757 -1 .01593 0 0)"
                ></path>
                <path
                  strokeWidth="0.667"
                  d="M234.71-317.83l-2.813-7.451c5.015-1.09 21.44-2.25 28.255.983-1.743 2.397-4.948 4.76-9.898 5.428-4.97.662-10.238.74-15.544 1.04z"
                  transform="matrix(.03259 .99785 -1 .03266 0 0)"
                ></path>
                <g strokeLinejoin="round">
                  <path
                    strokeLinecap="round"
                    strokeWidth="0.674"
                    d="M241.78-316.65l2.005-11.645c6.912-2.15 12.99-3.426 18.437-3.84-1.402 5.365-4.388 9.088-9.35 10.1-6.703 1.367-9.854 4.484-11.093 5.385zm0 0"
                    transform="matrix(.0827 1 -.99547 .08232 0 0)"
                  ></path>
                  <path
                    strokeWidth="0.667"
                    d="M300.63-232.45c.898.188 1.813.445 2.738.77-4.304 2.695-7.87 5.957-12.118 12.457-4.343 6.66 1.907 18.555 4.47 24.863 5.359 3.96 10.406 9.785 12.011 17.46.633 4.13-10.77 2.637-18.614-1.062-9.586-4.523-10.89-3.27-14.309-4.031-1.218-5.871 1.329-6.363 3.774-6.078-5.282-8.461-7.485-16.883-8.54-28.996-1.054 12.113-3.257 20.535-8.539 28.996 2.446-.285 4.989.207 3.774 6.078-3.418.762-4.723-.492-14.313 4.031-7.84 3.7-19.247 5.191-18.61 1.063 1.605-7.676 6.652-13.5 12.008-17.461 2.566-6.31 8.816-18.203 4.473-24.863-4.247-6.5-7.817-9.762-12.121-12.457a22.1 22.1 0 012.738-.77c-.649-.887-6.23-2.625-6.887-2.164-4.27 3.02-8.434 10.109-12.067 14.227-10.289 11.664-15.426 20.664-13.61 27.926 2.586 7.82 11.805 16.598-.41 15.078-12.211-1.516-22.337-18.258-25.587-38.398-1.207-7.473-1.906-13.727-2.723-18.848 6.668 2.379 9.622 4.746 11.391 7.672-.793-2.781-1.39-5.418-1.793-7.934 5.453.965 9.41 3.64 10.828 8.524a25.425 25.425 0 002.008 4.984c1.68-.594 3.852-.559 6.492.086 1.004-2.39 8.52-10.754 12.555-16.898 4.56-6.938 11.41-12.238 13.664-12.531 1.133-.145 1.48 2.36 1.23 5.812 11.915-.082 23.822-.152 35.498.243 11.676-.395 23.583-.325 35.497-.243-.25-3.453.098-5.957 1.227-5.812 2.257.293 9.11 5.594 13.664 12.53 4.039 6.145 11.555 14.509 12.555 16.899 2.644-.645 4.816-.68 6.492-.086.734-1.363 1.437-3.008 2.012-4.984 1.418-4.883 5.375-7.559 10.828-8.524-.403 2.516-1 5.152-1.797 7.934 1.773-2.926 4.727-5.293 11.39-7.672-.812 5.121-1.511 11.375-2.718 18.848-3.25 20.14-13.375 36.883-25.591 38.398-12.211 1.52-2.992-7.258-.406-15.078 1.816-7.262-3.32-16.262-13.61-27.926-3.637-4.117-7.797-11.207-12.071-14.227-.653-.461-6.235 1.277-6.887 2.164z"
                    transform="scale(.99997 -1)"
                  ></path>
                </g>
              </g>
              <g fill="#edb92e" fillOpacity="1">
                <path
                  strokeLinejoin="round"
                  strokeWidth="0.655"
                  d="M245.14 247.6c.917 1.183 4.564 1.91 9.499 3.207 7.998 1.85 13.134.334 15.174-4.611-3.724 3.007-7.673 4.083-11.573 2.27-5.253-2.443-8.222-4.042-9.53-4.044-.906.136-2.443 1.426-3.57 3.178z"
                  transform="matrix(.99998 -.19529 .19528 1 0 0)"
                ></path>
                <path
                  strokeWidth="0.673"
                  d="M313.04 178.33c9.371 1.015 8.922 7.16.16 15.839-1.676 1.661-2.254 1.61-2.61-.118-.624-3.017-3.96-4.8-5.71-2.5-1.192 1.564-.926 2.461-4.895 1.905-5.011 4.212-9.093 7.175-2.53 6.932 2.882-.11 5.105 1.575 8.866 1.426-1.113 2.163-1.312 2.414-1.914 2.598-3.644.721-7.484-1.56-11.16-.882-8.058 1.49 12.906-21.819 12.648-22.743-.664-2.343 5.04-6.547 7.145-2.456z"
                  transform="scale(1 .99686)"
                ></path>
              </g>
            </g>
            <path
              fill="none"
              strokeLinecap="round"
              strokeWidth="0.673"
              d="M-312.82-178.09c.777-2.214 2.258-4.243 4.445-6.096"
              transform="scale(-1 -.99706)"
            ></path>
          </g>
        </g>
        <path
          fill="#21231e"
          fillRule="evenodd"
          d="M314.82 182.06a.811.811 0 00-.887-.68.74.74 0 00-.672.848.811.811 0 00.887.68.74.74 0 00.672-.848"
        ></path>
        <g
          fill="none"
          stroke="#21231e"
          strokeMiterlimit="22.926"
          strokeOpacity="1"
        >
          <path
            strokeLinecap="round"
            strokeWidth="0.861"
            d="M263.67-112.07c2.326.733 5.01.324 8.442-.001.966-.095 4.35-.51 5.247-.126"
            transform="matrix(.99998 .25807 .25806 -1 0 0)"
          ></path>
          <path
            strokeLinecap="round"
            strokeWidth="0.633"
            d="M-291.93 92.081c2.6.406 4.062.535 5.329.593"
            transform="matrix(-.99997 -.32891 -.3289 1 0 0)"
          ></path>
          <path
            strokeWidth="0.689"
            d="M224.15 53.693c1.679-.312 3.868-.846 5.706-.12 1.384.545 1.408 2.388.549 4.45"
            transform="matrix(.81664 1 .99997 -.81667 0 0)"
          ></path>
        </g>
        <path
          fill="#21231e"
          fillRule="evenodd"
          d="M240.39 185.17l-1.234-1.234c-.602-.762-.254-1.774 1.046-3.04.95.41 1.707.727 2.47 1.044-.505 1.71-1.266 2.789-2.282 3.23"
        ></path>
        <path
          fill="none"
          stroke="#21231e"
          strokeMiterlimit="22.926"
          strokeOpacity="1"
          strokeWidth="0.689"
          d="M-40.454-270.31c1.679-.312 3.866-.848 5.704-.123 1.386.544 1.408 2.389.551 4.448"
          transform="matrix(-.81664 1 -.99997 -.81667 0 0)"
        ></path>
        <path
          fill="#21231e"
          fillRule="evenodd"
          d="M299.68 185.17l1.234-1.234c.606-.762.258-1.774-1.043-3.04-.953.41-1.71.727-2.468 1.044.504 1.71 1.265 2.789 2.277 3.23"
        ></path>
        <g stroke="#21231e" strokeMiterlimit="22.926" strokeOpacity="1">
          <g fill="none" strokeLinecap="round">
            <path
              strokeWidth="0.861"
              d="M-242.7-242.75c2.325.737 5.01.324 8.438-.002.969-.09 4.35-.506 5.251-.125"
              transform="matrix(-.99998 .25807 -.25806 -1 0 0)"
            ></path>
            <path
              strokeWidth="0.633"
              d="M195.43 252.38c2.607.412 4.066.537 5.331.597"
              transform="matrix(.99997 -.32891 .3289 1 0 0)"
            ></path>
            <g strokeLinejoin="round" strokeWidth="0.667">
              <g transform="scale(.99997 -1)">
                <path d="M236.72-231.68c5.348-1.875 10.184-1.504 13.809 2.066.574.563 1.121 1.102 1.633 1.614"></path>
                <path d="M252.81-224.74c-.496-3.606-1.418-6.48-2.692-9.336 3.77.98 6.75 2.707 8.571 5.309"></path>
                <path d="M269.98-235.8c-2.942 3.57-4.75 7.7-4.953 12.328"></path>
                <path d="M257.94-224.21c.332-3.61 1.363-6.695 3.04-9.086 1.812 1.371 3.57 3.613 4.374 6.824"></path>
              </g>
              <g transform="scale(-.99997 -1)">
                <path d="M-303.37-231.68c5.348-1.875 10.18-1.504 13.809 2.066.57.563 1.117 1.102 1.629 1.614"></path>
                <path d="M-287.28-224.74c-.496-3.606-1.422-6.48-2.695-9.336 3.773.98 6.75 2.707 8.57 5.309"></path>
                <path d="M-282.14-224.21c.328-3.61 1.36-6.695 3.035-9.086 1.817 1.371 3.57 3.613 4.375 6.824"></path>
                <path d="M-270.11-235.8c-2.942 3.57-4.75 7.7-4.953 12.328"></path>
              </g>
            </g>
            <g strokeWidth="0.667">
              <path
                d="M204.25-200.44c3.042 4.238 25.063 12.051 31.525 12.652 14.944 1.39 33.44 1.332 45.322-3.113"
                transform="matrix(0 .99513 -1 0 0 0)"
              ></path>
              <path
                d="M204.25 339.63c3.042 4.242 25.063 12.055 31.525 12.656 14.944 1.387 33.44 1.332 45.322-3.113"
                transform="matrix(0 .99513 1 0 0 0)"
              ></path>
            </g>
          </g>
          <path
            fill="#edb92e"
            fillOpacity="1"
            fillRule="evenodd"
            strokeLinejoin="round"
            strokeWidth="0.673"
            d="M-227.04 178.33c9.375 1.015 8.926 7.16.164 15.839-1.676 1.661-2.254 1.61-2.61-.118-.624-3.017-3.96-4.8-5.71-2.5-1.192 1.564-.926 2.461-4.895 1.905-5.015 4.212-9.097 7.175-2.535 6.932 2.887-.11 5.113 1.575 8.871 1.426-1.113 2.163-1.312 2.414-1.914 2.598-3.644.721-7.484-1.56-11.164-.882-8.059 1.49 12.91-21.819 12.652-22.743-.664-2.343 5.04-6.547 7.14-2.456z"
            transform="scale(-1 .99686)"
          ></path>
          <path
            fill="none"
            strokeLinecap="round"
            strokeWidth="0.673"
            d="M227.26-178.09c.773-2.214 2.258-4.243 4.441-6.096"
            transform="scale(1 -.99706)"
          ></path>
        </g>
        <path
          fill="#21231e"
          fillRule="evenodd"
          d="M225.26 182.06a.817.817 0 01.89-.68.74.74 0 01.672.848.811.811 0 01-.886.68.745.745 0 01-.676-.848"
        ></path>
        <g stroke="#21231e" strokeMiterlimit="22.926" strokeOpacity="1">
          <g fillRule="evenodd">
            <g fill="#fff">
              <path
                strokeLinejoin="round"
                strokeWidth="0.587"
                d="M-44.94 349.21l-2.734-4.67c1.39-1.999 6.643-3.549 11.005-.23 5.44 4.138 9.361 5.788 13.725 6.75-3.883 3.135-7.998 4.254-12.06 2.367-5.48-2.547-8.569-4.212-9.935-4.217z"
                transform="matrix(-.99998 .5396 .53958 1 0 0)"
              ></path>
              <path
                strokeWidth="0.603"
                d="M174.43 320.31l.282-6.516c5.59-.085 9.37-.155 11.333 0 3.847.306 7.082 1.42 9.47 3.247-1.609 1.94-4.384 3.746-8.427 3.945-4.06.194-8.352-.528-12.657-.676z"
                transform="matrix(-.47247 1 .99997 .47249 0 0)"
              ></path>
              <path
                strokeWidth="0.654"
                d="M268.03 292.69l.305-7.069c6.065-.092 10.17-.17 12.297 0 4.177.328 7.685 1.536 10.275 3.52-1.74 2.109-4.756 4.065-9.142 4.282-4.41.212-9.067-.574-13.734-.733z"
                transform="matrix(-.19727 1 .99998 .19727 0 0)"
              ></path>
              <path
                strokeLinejoin="round"
                strokeWidth="0.66"
                d="M344.03-190.35l.58-4.165c1.562-2.255 7.466-3.994 12.37-.262 6.114 4.652 10.525 6.507 15.428 7.59-4.364 3.52-8.99 4.782-13.558 2.658-6.157-2.865-13.286-5.818-14.82-5.821z"
                transform="matrix(.14684 1 -.99997 .14685 0 0)"
              ></path>
              <path
                strokeWidth="0.618"
                d="M184.83 317.46l.29-6.68c5.73-.087 9.606-.157 11.62 0 3.95.31 7.262 1.45 9.707 3.325-1.64 1.993-4.305 4.284-8.452 4.483-4.164.204-8.75-.977-13.165-1.128z"
                transform="matrix(-.40408 1 .99997 .4041 0 0)"
              ></path>
              <path
                strokeLinejoin="round"
                strokeWidth="0.51"
                d="M12.565 297.8l-3.679-6.137c.707-1.021 3.72.094 5.958.34.515.058 1.057.062 1.594.212 1.122.321 2.27.863 3.334 1.674 4.728 3.597 8.12 4.684 11.911 5.522-3.375 2.724-6.951 3.696-10.48 2.055-4.765-2.216-7.45-3.662-8.638-3.666z"
                transform="matrix(-.99997 .84188 .84187 1 0 0)"
              ></path>
            </g>
            <g fill="#edb92e" fillOpacity="1">
              <path
                strokeLinejoin="round"
                strokeWidth="0.662"
                d="M287.66-344.17c-.143-1.788.616-4.098 5.396-11.142 5.37-3.475 10.769-6.973 15.25-11.438.713-1.426 1.199-2.535 1.42-3.624.23-1.137-1.018-9.147-1.378-9.303-2.583-2.228-1.423-6.25 1.137-5.266.824-1.103 4.543.664 3.322 2.592-1.12 1.772.803 7.228.35 9.18 1.604-.911 2.087-6.11 1.916-9.683-.255-3.255 3.017-3.43 5.662-2.393 1.155 1.4-.219.3.556.765 2.335 1.192 2.43 4.325.334 4.683-2.169.37-4.093 8.27-5.63 9.603 3.146-1.785 5.848-5.352 8.9-7.33 1.51-1.911 1.73-2.985 5.463-1.2.014 2.475-.618 2.7.992 4.03.04 3.389-.89 4.048-3.612 3.829-2.878-.236-7.669 2.712-9.009 3.666-1.235.876-2.587 1.218-3.334 2.015-1.291 1.386-3.47 7.508-2.498 8.891 1.785 2.547 1.16 4.731-1.448 5.393-.788-.796-4.471.316-4.859-1.548-.314-1.524.05-2.498 1.039-4.05 1.554-2.45 2.39-3.71 2.096-4.42-.691-1.68-2.503 3.496-7.818 8.648-7.367 7.137-11.434 8.052-14.246 8.102z"
                transform="matrix(-.12042 .99535 -1 -.12098 0 0)"
              ></path>
              <path
                strokeWidth="0.659"
                d="M297.37-391.94c-1.632-2.017-1.77-3.3-.935-4.301.46-.553.094-1.112-.686-.635-3.256 1.992-3.335 4.407-1.391 6.267.635.506 1.176.91 1.713 1.313.471-.43.94-2.301 1.299-2.644z"
                transform="matrix(-.15013 .99966 -1 -.15019 0 0)"
              ></path>
              <path
                strokeWidth="0.65"
                d="M272.66 375.59c-1.063-2.646-.907-4.875.224-5.871.621-.55.411-1.267-.51-.865-3.861 1.668-4.633 4.44-3.197 6.965.498.705.926 1.28 1.355 1.849.947-.554 2.177-1.961 2.128-2.078z"
                transform="matrix(-.21494 1 .99442 .21375 0 0)"
              ></path>
              <path
                strokeWidth="0.659"
                d="M383.3 313.2c1.884 2.616 2.949 4.446 2.565 6.068-.227.95.314 1.705 1.097.786 3.178-3.714 2.626-7.32-.106-9.401-.914-.693-1.833-1.09-2.667-1.568-.818 1.041-.98 3.985-.889 4.115z"
                transform="matrix(.9986 .15606 -.15628 1 0 0)"
              ></path>
              <path
                strokeWidth="0.614"
                d="M186.22-422.2c-.02-2.222.698-3.296 2.033-3.78.735-.27.802-.857-.146-.767-6.356-.033-6.342 2.793-4.67 6.173 1.02-.198 2.782-1.528 2.783-1.626z"
                transform="matrix(-.42431 .99781 -1 -.42524 0 0)"
              ></path>
            </g>
          </g>
          <g fill="none">
            <path
              strokeWidth="0.493"
              d="M-353.01 1.925c-.267 1.226.207 1.747.747 1.853 1.144.227 1.196-.545 1.283-2.005"
              transform="matrix(-.91227 -1 .99998 -.91229 0 0)"
            ></path>
            <path
              strokeWidth="0.493"
              d="M-350.94 1.913c-.264 1.228.209 1.75.747 1.858 1.144.223 1.199-.548 1.285-2.008"
              transform="matrix(-.91227 -1 .99998 -.91229 0 0)"
            ></path>
            <path
              strokeWidth="0.674"
              d="M-347.23 321.03c1.11 1.627 2.344 1.725 3.176 1.297 1.754-.901.91-1.81-.711-3.512"
              transform="matrix(0 -1 .99656 0 0 0)"
            ></path>
            <path
              strokeWidth="0.677"
              d="M-344.76 319.19c1.258 1.727 2.648 1.833 3.59 1.382 1.984-.962 1.027-1.928-.805-3.737"
              transform="matrix(0 -1 .99509 0 0 0)"
            ></path>
            <path
              strokeWidth="0.669"
              d="M-342.14 315.57c1.332 1.603 2.652 2.104 3.813 1.377 1.816-1.146 1.09-1.92-.856-3.724"
              transform="matrix(0 -1 .99883 0 0 0)"
            ></path>
          </g>
          <g fill="#fff" fillRule="evenodd">
            <path
              strokeLinejoin="round"
              strokeWidth="0.587"
              d="M373.36 123.5l-2.737-4.668c1.392-2.001 6.646-3.55 11.008-.232 5.437 4.14 9.361 5.788 13.725 6.75-3.883 3.135-7.997 4.257-12.06 2.367-5.48-2.547-8.572-4.21-9.935-4.217z"
              transform="matrix(.99998 .5396 -.53958 1 0 0)"
            ></path>
            <path
              strokeWidth="0.603"
              d="M383.04-121.21l.282-6.516c5.59-.085 9.37-.155 11.333 0 3.849.302 7.084 1.417 9.47 3.247-1.609 1.94-4.384 3.746-8.426 3.942-4.062.197-8.356-.527-12.659-.673z"
              transform="matrix(.47247 1 -.99997 .47249 0 0)"
            ></path>
            <path
              strokeWidth="0.654"
              d="M370.58-227.17l.305-7.069c6.065-.092 10.17-.17 12.297 0 4.177.328 7.685 1.536 10.275 3.52-1.74 2.109-4.756 4.069-9.142 4.282-4.41.212-9.063-.573-13.734-.733z"
              transform="matrix(.19727 1 -.99998 .19727 0 0)"
            ></path>
            <path
              strokeLinejoin="round"
              strokeWidth="0.66"
              d="M266.39 338.33l.58-4.165c1.561-2.251 7.466-3.994 12.37-.262 6.114 4.652 10.525 6.507 15.432 7.591-4.364 3.52-8.995 4.78-13.562 2.657-6.157-2.865-13.286-5.818-14.82-5.821z"
              transform="matrix(-.14684 1 .99997 .14685 0 0)"
            ></path>
            <path
              strokeWidth="0.618"
              d="M372.45-146.82l.29-6.68c5.728-.092 9.607-.16 11.621-.003 3.95.31 7.26 1.453 9.706 3.328-1.645 1.992-4.304 4.28-8.452 4.483-4.168.203-8.753-.978-13.165-1.128z"
              transform="matrix(.40408 1 -.99997 .4041 0 0)"
            ></path>
            <path
              strokeLinejoin="round"
              strokeWidth="0.51"
              d="M328.64 31.702l-3.68-6.14c.708-1.018 3.72.095 5.955.342.517.057 1.06.061 1.598.213 1.12.32 2.267.861 3.334 1.674 4.726 3.595 8.118 4.681 11.91 5.52-3.375 2.724-6.951 3.696-10.48 2.055-4.763-2.214-7.45-3.662-8.636-3.664z"
              transform="matrix(.99997 .84188 -.84187 1 0 0)"
            ></path>
          </g>
          <path
            fill="#c6363c"
            fillOpacity="1"
            strokeWidth="1.334"
            d="M-323.29-236.47v-61.125c0-10.93 4.46-20.855 11.65-28.047 7.191-7.188 17.118-11.648 28.051-11.648h.004c10.932 0 20.856 4.46 28.047 11.648 7.191 7.191 11.65 17.117 11.65 28.047v61.125z"
            transform="scale(-.95223 -1)"
          ></path>
          <g fill="#fff">
            <path
              strokeWidth="0.667"
              d="M324.05-273.96v-15.754h-31.506v-46.703a39.737 39.737 0 00-8.29-.871h-.004c-2.837 0-5.613.3-8.285.871v46.703h-31.506v15.754h31.506v37.492h16.579v-37.492z"
              transform="scale(.94998 -1)"
            ></path>
            <g fillRule="evenodd" strokeLinejoin="round">
              <path
                strokeWidth="0.676"
                d="M-245.41-257.65h-22.145c-1.297 4.84-5.98 16.62 4.285 17.235 4.746.282 7.875-5.904 3.684-7.572-1.985-.787-3.387.07-3.844 1.233-.488 1.257.523 2.502 2.035 2.173-2.613 5.008-8.156-4.479-.941-8.758 2.105-1.25 4.293 2.102 5.851 2.106 1.559.004 3.891-3.293 5.852-2.106 7.18 4.334 1.672 13.766-.938 8.758 1.508.329 2.524-.916 2.036-2.173-.457-1.163-1.86-2.02-3.844-1.233-4.192 1.668-1.063 7.854 3.683 7.572 10.262-.615 5.582-12.396 4.286-17.235z"
                transform="matrix(0 -1 -.99769 0 0 0)"
              ></path>
              <g strokeWidth="0.671">
                <path
                  d="M-245.41 283.68h-22.145c-1.297 4.84-5.98 16.62 4.285 17.235 4.746.286 7.875-5.904 3.684-7.568-1.985-.795-3.387.066-3.844 1.23-.488 1.256.523 2.505 2.035 2.172-2.613 5.008-8.156-4.475-.941-8.758 2.105-1.25 4.293 2.106 5.851 2.11 1.559.004 3.891-3.297 5.852-2.11 7.18 4.334 1.672 13.766-.938 8.758 1.508.333 2.524-.916 2.036-2.173-.457-1.163-1.86-2.024-3.844-1.23-4.192 1.665-1.063 7.855 3.683 7.569 10.262-.615 5.582-12.396 4.286-17.235z"
                  transform="matrix(0 -1 .99769 0 0 0)"
                ></path>
                <path
                  d="M318.28-257.65h-22.148c-1.297 4.84-5.977 16.62 4.29 17.235 4.745.282 7.874-5.904 3.683-7.572-1.985-.787-3.39.07-3.844 1.233-.488 1.257.523 2.502 2.035 2.173-2.61 5.008-8.156-4.479-.941-8.758 2.101-1.25 4.293 2.102 5.851 2.106 1.559.004 3.89-3.293 5.852-2.106 7.183 4.334 1.672 13.766-.938 8.758 1.508.329 2.52-.916 2.032-2.173-.454-1.163-1.86-2.02-3.844-1.233-4.192 1.668-1.059 7.854 3.683 7.572 10.27-.615 5.586-12.396 4.29-17.235z"
                  transform="matrix(0 1 -.99769 0 0 0)"
                ></path>
                <path
                  d="M318.28 283.68h-22.148c-1.297 4.84-5.977 16.62 4.29 17.235 4.745.286 7.874-5.904 3.683-7.568-1.985-.795-3.39.066-3.844 1.23-.488 1.256.523 2.505 2.035 2.172-2.61 5.008-8.156-4.475-.941-8.758 2.101-1.25 4.293 2.106 5.851 2.11 1.559.004 3.89-3.297 5.852-2.11 7.183 4.334 1.672 13.766-.938 8.758 1.508.333 2.52-.916 2.032-2.173-.454-1.163-1.86-2.024-3.844-1.23-4.192 1.665-1.059 7.855 3.683 7.569 10.27-.615 5.586-12.396 4.29-17.235z"
                  transform="matrix(0 1 .99769 0 0 0)"
                ></path>
              </g>
            </g>
          </g>
          <path
            fill="none"
            strokeWidth="1.334"
            d="M-323.29-236.47v-61.125c0-10.93 4.46-20.855 11.65-28.047 7.191-7.188 17.118-11.648 28.051-11.648h.004c10.932 0 20.856 4.46 28.047 11.648 7.191 7.191 11.65 17.117 11.65 28.047v61.125z"
            transform="scale(-.95223 -1)"
          ></path>
        </g>
      </g>
    </g>
  </svg>
);

export default SrFlag;
